import {
    FILTER_RATES_BY_CARRIER,
    FINAL_SEARCH_FORM,
    RE_SORT_RATE_CARD,
    SAVE_SEARCH_FORM_PARAM,
    SET_AIR_JSON, SET_CLIENT_JWT,
    SET_FILTER_BY_CHEAPER,
    SET_INIT_AUTH,
    SET_JWT_TOKEN,
    SET_PORT_DESTINATION_JSON,
    SET_PORT_ORIGIN_JSON,
    SET_QUERY_PARAMS,
    SET_FAK_NAC_PERCENT,
    SET_RATE_PROFILE,
    SET_ROUTE_SUBSCRIPTIONS,
    SET_REFERRAL_DATA,
    SET_SEA_FCL_JSON,
    SET_SEA_LCL_JSON,
    SET_SHOW_RESULT_CARD,
    SET_URL,
    SET_UUID_URL_PARAMS_DATA,
    SHOW_FORM,
    SHOW_BACK_PORTAL,
    UPDATE_ERROR,
    UPDATE_PICKUP_DELIVERY_ERS_LINE,
    UPDATE_POSTAL_ZIP_CODE,
    SET_DISCOUNT,
    SET_COMMODITY_CATEGORY_LIST,
    INSURANCE_AUTH_TOKEN,
    UPDATE_TRANSIT_TIME,
    UPDATE_PORT_TO_PORT_TRANSIT_TIME,
    SET_SELECTED_SCHEDULE,
    BOOKING_CUSTOMER_FORM,
    SET_SELECTED_CARRIER,
    SET_SELECTED_ETD_SCHEDULE,
    SET_SELECTED_ETA_SCHEDULE,
    SET_SCHEDULE_ID,
    SET_EXTERNAL_API_ORIGIN_CHARGES,
    SET_EXTERNAL_API_DESTINATION_CHARGES,
    SET_EXTERNAL_API_PICKUP_CHARGES,
    SET_EXTERNAL_API_DELIVERY_CHARGES,
    SET_DELIVERY_ACCESSORIALS,
    SET_PICKUP_ACCESSORIALS,
    SET_PICKUP_CHARGE_ERROR,
    SET_DELIVERY_CHARGE_ERROR,
    SET_PICKUP_POSTAL_CODE,
    SET_DELIVERY_POSTAL_CODE,
    SET_DELIVERY_DRAYAGE_LOADING,
    RESET_CHARGES,
    RESTORE_EXTERNAL_LCL_CHARGES,
    RESET_PICKUP_ORIGIN_CHARGES,
    RESET_DELIVERY_DESTINATION_CHARGES,
    RESET_PICKUP_CHARGES_ONLY,
    RESET_DELIVERY_CHARGES_ONLY,
    TOGGLE_ROUTE_SUBSCRIPTION,
    FCL_WEIGHTS_APPLIED_CMA,
    FCL_SCHEDULE_DATA,
    SET_DEFAULT_DESTINATION_CHARGES,
} from './types';

import {
    API_KEY,
    AUTH_TOKEN,
    BOOK_NOW_URL,
    REMOVE_FCL_45_HC_CONTAINER,
    SAILING_SCHEDULE_POST_URL,
    SAVE_QUOTE_URL,
    SEARCH_BAR_URL,
    SEARCH_CONTACT_FORM_URL,
    SEARCH_SAILING_SCHEDULE_TIMEOUT_MIN,
    SHOW_CUSTOM_PORTS_DROPDOWN,
    G_MAP_API_KEY,
    SMART_MULTIPORT,
} from '../envVariables';
import {
    runParallelLaneSearch,
    tagLaneResults,
    dedupeRates,
    structuralRateKey,
} from '../util/portPicker/searchExecutor';

import localFCLJSON from '../data/sea-fcl.json';
import localLCLJSON from '../data/sea-lcl.json';
import localAIRJSON from '../data/air.json';
import localInsuranceCategoriesJSON from '../data/insurance-categories.json';
import localPurchaseOrdersJSON from '../data/sample-purchase-orders.json';
import {
    add_transit_time,
    get_all_ports,
    get_buying_rate,
    get_Client_Rate,
    get_commodity_list,
    setting_JSON_For_Redux_Store,
    get_factor_details_from_database,
    Set_Input_parameter,
    getBuyingRatesForRateSheet,
    sendSaveQuote,
    getAgentProfilesData,
    getCargoInsurance,
    getCargoInsurancePolicy,
    validateUserEntityForBreezeApi,
    updateEntityLocation,
    searchPurchaseOrdersDetailed
} from '../GraphQL/entities'
import { get_default_charges_from_bb } from '../GraphQL/getDefaultCharges';
// sailing schedule post response json
import localSailingScheduleJSON from '../data/sailing-schedule-post-res.json';
import configureStore from '../store';

// zip code post response
import localZipCodePostJSON from '../data/zip-code-post.json';

import axios from 'axios';
import qs from 'qs';
import sortBy from 'lodash/sortBy';
import {isEmpty} from '../util/isEmpty';
import {isDevENV} from '../util/isDevENV';
import {tryParseJSON} from '../util/tryParseJSON';
import getNewRatesByUUID from '../util/getNewRatesByUUID';
import {updateOriginalRateJson} from '../util/updateOriginalRateJson';
import {getPostalUpdatedFclLclAirJson} from '../util/getPostalUpdatedFclLclAirJson';
import {getActiveShipmentMode} from '../util/getActiveShipmentMode';
import {getSailingPOSTparam} from '../util/getSailingPOSTparam';
import {
    setFormZipCodeSubmitLoading,
    setOverlayFullScreen,
    setOverlayProgress,
    setTransparentOverlay,
    showSearchBlurCards,
    updateParentScrollbarPosition,
    updateRateCardsInfo,
    resetContainersTypeSliders
} from './code_config_actions';

import {getFclOverweightContainer} from '../util/getFclOverweightContainer';
// import {
//   saveSearchOriginPortsJson,
//   saveSearchDestinationPortsJson,
// } from './cache_actions-d';
// import { isPortCacheValid } from '../util/cacheUtils-d';
import {checkFcl45hqPrice} from '../util/checkFcl45hqPrice';
import {resetSidebarRoleIncoterm, updateSidebarRoleIncoterm,} from '../util/updateSidebarRoleIncoterm';
import {shouldRedirectChild} from '../util/shouldRedirectChild';
import {cleanPickupDeliveryJson} from '../util/cleanPickupDeliveryJson';
import { makeGCPRequestForLCLCharges } from '../GraphQL/lclExternalRates';

import { buildSaveQuotePayload, adaptSectionCharges } from "../util/saveQuotePayload"
import { convertToMetric } from '../util/convertToMetric';
import { calculateLocalCharge } from '../util/ecuNormalizationCharge';
import { get_rate_profile_from_bb } from '../GraphQL/rateProfile';
import { get_all_ports_from_db } from '../GraphQL/portsData';
import { get_route_subscriptions_from_bb, addRouteSubscription, deleteRouteSubscription } from '../GraphQL/routeSubscriptions';
import { makeGCPRequestForFCLExternalRate } from '../GraphQL/getSpotOnRate';
import { setting_JSON_For_Redux } from '../GraphQL/settingReduxStore';
import { findStateCodeByCityAndCountryName } from '../util/countryList';
import { get_fcl_drayage_from_bb } from '../GraphQL/getFclDrayage';
// axios already imported above
// import {
//     LANDING_PAGE_SEARCH_CLICK_URL,
//   } from '../envVariables';

// Cache to prevent duplicate calls
let postDoorLocationDataCache = new Map();
const drayageInFlight = new Set();
/**
 * @module route_action
 * @redux
 * @description These are redux actions creators related to Search page.
 * @category Search Page
 * @subcategory actions
 */

const GEO_API_KEY = process.env.REACT_APP_GMAP_API || process.env.REACT_APP_G_MAP_API_KEY || G_MAP_API_KEY;

// Generic geocode lookup using Google Maps Geocoding API (all countries)
const geocodePostal = async (postalCode) => {
    if (!postalCode || !GEO_API_KEY) return null;
    try {
        const params = {
            address: postalCode,
            key: GEO_API_KEY,
        };

        const { data } = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', { params });
        if (data?.status !== 'OK' || !Array.isArray(data?.results) || !data.results[0]) return null;
        const components = data.results[0].address_components || [];
        const city =
            components.find(c => c.types.includes('locality'))?.long_name ||
            components.find(c => c.types.includes('postal_town'))?.long_name ||
            components.find(c => c.types.includes('sublocality'))?.long_name;
        const state = components.find(c => c.types.includes('administrative_area_level_1'))?.short_name;
        const country = components.find(c => c.types.includes('country'))?.short_name;
        return { city, state, country };
    } catch (err) {
        console.error('Geocode lookup failed', err.message || err);
        return null;
    }
};

/**
 * @function
 * @name getQueryParams
 * @description It gets query params from url
 * @param {string} fullUrl - browser address url
 * @returns {Object} query params
 * @example
 * console.log(getQueryParams(
 * "http://ratesearch.primefreight.com/?from=%257B%2522id%2522%253A653441%252C%2522name%2522%253A%2522Chittagong%2522%252C%2522country%2522%253A%2522Bangladesh%2522%257D&to=%257B%2522id%2522%253A16%252C%2522name%2522%253A%2522Coffs%2520Harbour%2522%252C%2522country%2522%253A%2522Australia%2522%257D&date=19%20May%2C%202021&type=api-fcl"
 * ));
 *
 * //output
 * {
 * date: "19 May, 2021",
 * from: {country: "Bangladesh", id: 65441, name: "Chittagong"},
 * to: {country:"Australia", id: 65341, name: "Coffs Harbour"},
 * type: "api-fcl"
 * }
 */
const getQueryParams = (fullUrl) => {
    fullUrl =
        fullUrl && !isEmpty(fullUrl) && new URL(fullUrl).search.substring(1);
    let query_params = qs.parse(fullUrl);
    // console.log({ query_params });

    if (tryParseJSON(decodeURIComponent(query_params.from))) {
        query_params = {
            ...query_params,
            from: tryParseJSON(decodeURIComponent(query_params.from)),
        };
    }

    if (tryParseJSON(decodeURIComponent(query_params.to))) {
        query_params = {
            ...query_params,
            to: tryParseJSON(decodeURIComponent(query_params.to)),
        };
    }

    if (tryParseJSON(decodeURIComponent(query_params.discount))) {
        query_params = {
            ...query_params,
            discount: tryParseJSON(decodeURIComponent(query_params.discount)),
        };
    }

    //if url params from/to objects have city keys instead of name then map it to name
    if (!isEmpty(query_params.from)) {
        let tempFrom = query_params.from;
        query_params = {
            ...query_params,
            from: {
                id: tempFrom.id,
                name: tempFrom.name || tempFrom.city,
                country: tempFrom.country,
            },
        };
    }

    if (!isEmpty(query_params.to)) {
        let tempTo = query_params.to;
        query_params = {
            ...query_params,
            to: {
                id: tempTo.id,
                name: tempTo.name || tempTo.city,
                country: tempTo.country,
            },
        };
    }

    // console.log('getQueryParams queryParams: ', query_params);
    if(query_params.date === ''){
        const currentDate = new Date()
        query_params ={
            ...query_params,
            date: currentDate
        }
    }
    return query_params;

};

/**
 * @function
 * @name setURL
 * @description  It saves url in redux store so it can be used in browser address field
 * @param {Function} dispatch - redux dispatch
 * @param {Object} queryParams - query params
 * @returns {Redux.Action} The generated action
 */
export const setURL = async (dispatch, queryParams) => {
    let tempQueryParams = {
        ...queryParams,
        from: encodeURIComponent(JSON.stringify(queryParams.from)),
        to: encodeURIComponent(JSON.stringify(queryParams.to)),
    };

    const query = qs.stringify({
        ...tempQueryParams,
    });
    const url = `?${query}`;
    dispatch({
        type: SET_URL,
        payload: url,
    });
};

export const setFclJson = (seaFCLJSON) => async (dispatch, getState) =>{
   dispatch({
        type: SET_SEA_FCL_JSON,
        payload: seaFCLJSON,
    });
}


export const setFclWeightsApplied = (isApplied) => async (dispatch, getState) =>{
   dispatch({
        type: FCL_WEIGHTS_APPLIED_CMA,
        payload: isApplied,
    });
}

export const setFclScheduleData = (scheduleData) => async (dispatch, getstate) =>{
    dispatch({
        type: FCL_SCHEDULE_DATA,
        payload: scheduleData,
    });
}

export const setRateProfile = (profileData) => async (dispatch, getstate) =>{
    dispatch({
        type: SET_RATE_PROFILE,
        payload: profileData
    })
}

export const setRouteSubscriptions = (routeSubscriptionData) => async (dispatch, getstate) =>{
    dispatch({
        type: SET_ROUTE_SUBSCRIPTIONS,
        payload: routeSubscriptionData
    })
}

export const setJWTForRedux = async (dispatch) => {
    // PROXY_BETTY=YES → mint the anonymous JWT via the same-origin /api/betty-login function.
    // Read process.env INLINE (not the imported PROXY_BETTY const): CRA inlines the flag's
    // literal here, so with PROXY_BETTY=YES the minifier constant-folds the ternary and the
    // direct Betty mint URLs below are DROPPED from the prod bundle (imported-const reads
    // can't fold across modules — the dead-branch strings shipped until v0.2.10).
    const LOGIN_URL = process.env.REACT_APP_PROXY_BETTY === "YES"
        ? "/api/betty-login"
        : isDevENV() ? "https://primefreight-portal-dev.herokuapp.com/proxy-request?url=https://primefreight.bettywebblocks.com/public_user" : "https://primefreight.bettywebblocks.com/public_user"
    const MAX_RETRIES = 3;
    let attempt = 0;
    let response = null;

    while (attempt < MAX_RETRIES) {
        // console.log("attempt: ",attempt)
        try {
            response = await API_Call_For_JWT(LOGIN_URL);
            // Manually throw if response is undefined or missing token
            if (!response || !response.jwtToken) {
                throw new Error("Invalid response from JWT API");
            }
            break; // success, exit the loop
        } catch (error) {
            attempt++;
            if (attempt === MAX_RETRIES) {
                console.error("Failed to get JWT after 3 attempts", error);
                dispatch(updateErrorAndLoading(error, false));
                return;
            }
        }
    }

    // If response is valid, proceed to dispatch
    if (response && response?.jwtToken) {
        let payload = {
            "JWT_TOKEN": response?.jwtToken,
            "Access_Expire_AT": response?.accessExpiresAt,
            "Refresh_Token": response?.refreshToken
        };

        dispatch({
            type: SET_JWT_TOKEN,
            payload: payload,
        });
    }
};


// export const getFactory = (callback) => async (dispatch,getState) => {
//  let response= await get_factor_details_from_database(getState)
//   if(response.status ==="200"){
//
//   }else{
//     dispatch(updateErrorAndLoading(response.message, false));
//   }
// }

export const getDestinationCharges = () => async (dispatch, getState) => {
    // console.log("getDestinationCharges is executing..............")
    let defaultDestinationCharges = []
    try{
        const result = await get_default_charges_from_bb(getState);
        // console.log("result: ",result);
        if (result && result[0] === 200 && result[1] && Array.isArray(result[1]) && result[1].length > 0) {
            defaultDestinationCharges = result[1].filter(charge => parseFloat(charge.unitCost) > 0);
            // console.log("destinationCharges: ",defaultDestinationCharges)
        }
        dispatch({ type: SET_DEFAULT_DESTINATION_CHARGES, payload: defaultDestinationCharges });
    }catch(error){
        console.error(error)
    }
};

/**
 * @function
 * @name getInitAuth
 * @description  it saves user and verification in redux store
 * @param {Function} callback - callback
 * @returns {Redux.Action} The generated action
 */
export const getInitAuth = (callback) => async (dispatch, getState) => {
    let queryParams = getQueryParams(window.location.href);
    // if user and verification not present, then get it from top level
    // client said it doesn't have to get uuid/verification from parent site url
    // still I am adding it
    if (!queryParams.user && !queryParams.verification) {
        queryParams = getQueryParams(document.referrer);
    }

    const auth = {
        user: queryParams.user,
        verification: queryParams.verification
    };


    if (queryParams.showForm && queryParams.showForm.toLowerCase() === 'true') {
        dispatch({type: SHOW_FORM, payload: true});
    } else {
        dispatch({type: SHOW_FORM, payload: false});
    }

    if(isDevENV() || (queryParams.showBackBtn && queryParams.showBackBtn.toLowerCase() === 'true')) {
        dispatch({type: SHOW_BACK_PORTAL, payload: true});
    } else {
        dispatch({type: SHOW_BACK_PORTAL, payload: false});
    }

    dispatch({
        type: SET_INIT_AUTH,
        // payload: JSON.stringify(auth),
        payload: auth,
    });

    if (queryParams.discount !== undefined) {
        const currentQueryParams = getState().route.queryParams || {};
        dispatch({
            type: SET_QUERY_PARAMS,
            payload: {
                ...currentQueryParams,
                discount: queryParams.discount,
            },
        });
    }

    if (queryParams.token !== undefined && queryParams.expire_at !== undefined) {

        let payload = {
            "JWT_TOKEN": queryParams.token,
            "Access_Expire_AT": queryParams.expire_at,
            "Refresh_Token": queryParams.token
        }

        dispatch({
            type: SET_CLIENT_JWT,
            payload: payload,
        });

        // Query to add factory and shipper details to store
        let response = await get_Client_Rate(getState, {}, false, dispatch, true)
        if (response.status !== "200") {
            dispatch(updateErrorAndLoading(response.error, false));
        }

    }
    let percentagePayload = {
        fakPercentage: 0.5,
        nacPercentage: 0.5
    }
    if((queryParams.fak_percentage && queryParams.fak_percentage !== "") &&
       (queryParams.nac_percentage && queryParams.nac_percentage !== "")){
        console.log("fak and nac are present", queryParams?.fak_percentage, queryParams?.nac_percentage)
        percentagePayload = {
            fakPercentage: queryParams.fak_percentage/100,
            nacPercentage: queryParams.nac_percentage/100
        }
    }
  
    dispatch({
        type: SET_FAK_NAC_PERCENT,
        payload: percentagePayload,
    });

    if (callback) {
        // Pass the FRESH USER_DETAILS (from the store, post-bootstrap) so callers can
        // decide login state without racing connect's re-render of their props
        // (#rfq-creator-token: the handoff creator was reading stale props → wrong home redirect).
        callback(getState().route.USER_DETAILS);
    }
};

/**
 * @function
 * @name getReferralData
 * @description  it saves referral_code and referral_type in redux store
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
// TODO-it doesn't appear during landing page to search page transition
export const getReferralData =
    (callback = undefined) =>
        async (dispatch) => {
            let queryParams = getQueryParams(window.location.href);

            // if referral code and referral type not present, then get it from top level
            // client said it doesn't have to get uuid/verification from parent site url
            // still I am adding it
            if (!queryParams.referral_code && !queryParams.referral_type) {
                queryParams = getQueryParams(document.referrer);
            }

            // console.log(
            //   'getReferralData: react app: ',
            //   JSON.stringify(window.location.href),
            //   ', wp site:',
            //   JSON.stringify(document.referrer)
            // );

            const refferal = {
                referral_code: queryParams.referral_code,
                referral_type: queryParams.referral_type,
            };

            // console.log({ refferal });

            dispatch({
                type: SET_REFERRAL_DATA,
                payload: refferal,
            });

            if (callback) {
                callback();
            }
        };


/**
 * @function
 * @name getUuidUrlParams
 * @description  it saves req_uuid and uuid_verification in redux store
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getUuidUrlParams =
    (callback = undefined) =>
        async (dispatch) => {
            let queryParams = getQueryParams(window.location.href);

            // if "req_uuid" and "uuid_verification" not present, then get it from top level
            // client said it doesn't have to get uuid/verification from parent site url
            // still I am adding it
            if (!queryParams.req_uuid && !queryParams.uuid_verification) {
                queryParams = getQueryParams(document.referrer);

            }

            const uuid = {
                req_uuid: queryParams.req_uuid,
                uuid_verification: queryParams.uuid_verification,
            };

            // console.log({ uuid });

            dispatch({
                type: SET_UUID_URL_PARAMS_DATA,
                payload: uuid,
            });

            if (callback) {
                callback();
            }
        };


export const filter_rates_by_carrier = (company_name, checkbox) => async (dispatch, getState) => {
    let all_fcl_rates = getState().route.seaFCLJSON

    if (!checkbox) {
        all_fcl_rates.rates.fcl = all_fcl_rates.rates.fcl.map((object, index) => {
            return {...object, blockRoute: false};
        });
        if(all_fcl_rates.rates.filteredJson && all_fcl_rates.rates.filteredJson.length > 0){
            all_fcl_rates.rates.filteredJson = all_fcl_rates.rates.filteredJson.map((object, index) => {
                return {...object, blockRoute: false};
            });
        }
    } else if (company_name !== "") {
        all_fcl_rates.rates.fcl = all_fcl_rates.rates.fcl.map((object, index) => {
            return {...object, blockRoute: false};
        });
        if(all_fcl_rates.rates.filteredJson && all_fcl_rates.rates.filteredJson.length > 0){
            all_fcl_rates.rates.filteredJson = all_fcl_rates.rates.filteredJson.map((object, index) => {
                return {...object, blockRoute: false};
            });
        }
        all_fcl_rates.rates.fcl = all_fcl_rates.rates.fcl.map((object, index) => {
            if (object.sealine !== company_name) {
                return {...object, blockRoute: true};
            }
            return object;
        });
        if(all_fcl_rates.rates.filteredJson && all_fcl_rates.rates.filteredJson.length > 0){
            all_fcl_rates.rates.filteredJson = all_fcl_rates.rates.filteredJson.map((object, index) => {
                if (object.sealine !== company_name) {
                    return {...object, blockRoute: true};
                }
                return object;
            });
        }
    }

    dispatch({
        type: FILTER_RATES_BY_CARRIER,
        payload: all_fcl_rates
    })
}

export const toggleRouteSubscription = (
    from,
    to,
    source = 'global',
    rateId = undefined,
    carrierId = undefined,
    dischargePortId = undefined,
    routeSubscriptionId = undefined,
    isFcl = undefined,
    isLcl = undefined,
) => ({

    type: TOGGLE_ROUTE_SUBSCRIPTION,
    payload: {
        fromId: from?.id,
        toId: to?.id,
        fromName: from?.name || from?.city || from?.company_name || from?.companyName || '',
        toName: to?.name || to?.city || to?.company_name || to?.companyName || '',
        source,
        rateId,
        carrierId,
        dischargePortId,
        routeSubscriptionId,
        isFcl,
        isLcl,
    },
});

/**
 * Ensure a single lane-level subscription exists for the given origin/destination.
 * If carrier/discharge-specific subs exist, delete them and replace with a lane-only sub.
 * Returns the lane subscription id and the updated list.
 */
export const ensureLaneSubscription = (from, to, { isFcl, isLcl } = {}) => async (dispatch, getState) => {
    const fromId = from?.id;
    const toId = to?.id;
    if (!fromId || !toId) return { routeSubscriptionId: undefined, updatedList: getState()?.route?.routeSubscriptions || [] };

    const entityId = getState()?.route?.USER_DETAILS?.id;
    if (!entityId) return { routeSubscriptionId: undefined, updatedList: getState()?.route?.routeSubscriptions || [] };

    const existing = getState()?.route?.routeSubscriptions || [];

    const modeCovers = (item) => {
        if (item.isFcl == null && item.isLcl == null) return true; // backwards compat
        if (isFcl && item.isFcl === true) return true;
        if (isLcl && item.isLcl === true) return true;
        return false;
    };

    // Only consider subscriptions for this route that cover the requested mode
    const matching = existing.filter(
        (item) =>
            (item.fromId === fromId || item.originPort === fromId) &&
            (item.toId === toId || item.destinationPort === toId) &&
            modeCovers(item)
    );

    // Lane sub for the current mode
    const laneOnlyExisting = matching.find(
        (item) => !item.carrierId && !item.carrier && !item.dischargePortId && !item.dischargePort
    );
    let laneRouteId = laneOnlyExisting?.routeSubscriptionId || laneOnlyExisting?.id;

    // Lane sub for the opposite mode (no carrier/discharge, same origin/destination)
    const oppositeLane = !laneRouteId && existing.find(item =>
        (item.fromId === fromId || item.originPort === fromId) &&
        (item.toId === toId || item.destinationPort === toId) &&
        !item.carrier && !item.carrierId &&
        !item.dischargePort && !item.dischargePortId &&
        (item.isFcl != null || item.isLcl != null) &&
        ((isFcl && item.isLcl === true && item.isFcl !== true) ||
         (isLcl && item.isFcl === true && item.isLcl !== true))
    );

    // Delete all current-mode specific subs.
    // If oppositeLane exists we will merge into it — no need to keep a convert candidate.
    // If no oppositeLane, keep one specific to convert into a lane sub.
    const specificMatches = matching.filter(
        (item) => item.carrierId || item.carrier || item.dischargePortId || item.dischargePort
    );
    const convertTarget = oppositeLane ? null : specificMatches[0];
    const convertId = convertTarget?.routeSubscriptionId || convertTarget?.id;

    for (const sub of specificMatches) {
        const subId = sub.routeSubscriptionId || sub.id;
        if (!subId) continue;
        if (!oppositeLane && convertId && subId === convertId) continue; // keep one to convert only when no oppositeLane
        await deleteRouteSubscription(subId, getState);
    }

    if (laneRouteId) {
        // Lane sub already covers the requested mode — no action needed
    } else if (oppositeLane) {
        // console.log("==== oppositeLane exists =====",oppositeLane)
        // Opposite-mode lane exists — update it to cover both modes
        const oppositeLaneId = oppositeLane.routeSubscriptionId || oppositeLane.id;
        const result = await addRouteSubscription(
            {
                carrier: null,
                originPort: fromId,
                destinationPort: toId,
                dischargePort: null,
                newRoute: !oppositeLaneId,
                routeSubscriptionId: oppositeLaneId,
                isFcl: oppositeLane.isFcl === true || isFcl === true,
                isLcl: oppositeLane.isLcl === true || isLcl === true,
            },
            getState
        );
        if (Array.isArray(result) && result[0]) {
            laneRouteId = oppositeLaneId || result[1];
        }
    } else {
        // console.log("== No lane sub at all ====", isFcl, isLcl);
        // No lane sub at all — create one (or convert a specific sub if available)
        const result = await addRouteSubscription(
            {
                carrier: null,
                originPort: fromId,
                destinationPort: toId,
                dischargePort: null,
                newRoute: convertId ? false : true,
                routeSubscriptionId: convertId,
                isFcl,
                isLcl,
            },
            getState
        );
        if (Array.isArray(result) && result[0]) {
            laneRouteId = convertId || result[1];
        }
    }

    const mergedLaneEntry = oppositeLane || laneOnlyExisting;
    // Remove all mode-matching subs for this route, plus the opposite-lane entry if we merged into it
    const cleanedList = existing.filter(item => {
        const sameRoute =
            (item.fromId === fromId || item.originPort === fromId) &&
            (item.toId === toId || item.destinationPort === toId);
        if (!sameRoute) return true;
        const itemId = item.routeSubscriptionId || item.id;
        // Remove the opposite-lane entry we merged into
        if (oppositeLane && itemId === (oppositeLane.routeSubscriptionId || oppositeLane.id)) return false;
        // Remove current-mode-matching subs
        if (modeCovers(item)) return false;
        return true;
    });

    if (laneRouteId) {
        cleanedList.push({
            originPort: fromId,
            destinationPort: toId,
            carrier: null,
            dischargePort: null,
            id: laneRouteId,
            source: 'global',
            isFcl: mergedLaneEntry?.isFcl || isFcl,
            isLcl: mergedLaneEntry?.isLcl || isLcl,
        });
    }

    dispatch({ type: SET_ROUTE_SUBSCRIPTIONS, payload: cleanedList });

    return { routeSubscriptionId: laneRouteId, updatedList: cleanedList };
};


export const subscribeRouteIfNeeded = (payload) => async (dispatch, getState) => {
    const { originPort, destinationPort, dischargePort, carrier, isFcl, isLcl } = payload || {};
    if (!originPort || !destinationPort) return false;

    const existing = getState()?.route?.routeSubscriptions || [];

    const modeMatch = (sub) => {
        if (sub.isFcl == null && sub.isLcl == null) return true; // backwards compat
        if (isFcl && sub.isFcl === true) return true;
        if (isLcl && sub.isLcl === true) return true;
        return false;
    };

    const sameRouteCarrierDischarge = (item) => {
        if (item.originPort !== originPort || item.destinationPort !== destinationPort) return false;
        const carrierMatch = carrier
            ? (item.carrier === carrier || item.carrierId === carrier)
            : (!item.carrier && !item.carrierId);
        const dischargeMatch = dischargePort
            ? (item.dischargePort === dischargePort || item.dischargePortId === dischargePort)
            : (!item.dischargePort && !item.dischargePortId);
        return carrierMatch && dischargeMatch;
    };

    const laneOnlyMatch = existing.find(item =>
        (item.originPort === originPort) &&
        (item.destinationPort === destinationPort) &&
        !item.carrier &&
        !item.dischargePort &&
        modeMatch(item)
    );
    const laneOnlyId = laneOnlyMatch?.routeSubscriptionId || laneOnlyMatch?.id;

    // Already subscribed for the requested mode — return existing id
    const existingMatch = existing.find(item => {
        if (!sameRouteCarrierDischarge(item)) return false;
        if (!modeMatch(item)) return false;

        let carrierMatch = null, dischargeMatch = null;
        if(item.carrier && !item.dischargePort){
            carrierMatch = item.carrier === carrier;
        }
        if(!item.carrier && item.dischargePort){
            dischargeMatch = (item.dischargePort === dischargePort);
        }
        if (item.carrier && item.dischargePort){
            carrierMatch = (item.carrier === carrier);
            dischargeMatch = (item.dischargePort === dischargePort);
        }
        return carrierMatch && dischargeMatch;
    });

    if (existingMatch) {
        return existingMatch.routeSubscriptionId || existingMatch.id || false;
    }

    // Subscription exists for the same route but with only the opposite mode active
    // → update it to cover both modes instead of creating a duplicate
    const oppositeModeMatch = existing.find(item => {
        if (!sameRouteCarrierDischarge(item)) return false;
        if (item.isFcl == null && item.isLcl == null) return false; // no mode info — don't merge
        const alreadyHasCurrent = (isFcl && item.isFcl === true) || (isLcl && item.isLcl === true);
        const hasOpposite = (isFcl && item.isLcl === true) || (isLcl && item.isFcl === true);
        return !alreadyHasCurrent && hasOpposite;
    });

    if (oppositeModeMatch) {
        // Merge: update the existing subscription to add the current mode
        const existingId = oppositeModeMatch.routeSubscriptionId || oppositeModeMatch.id;
        // console.log("oppositeModeMatch--existingId----",existingId);
        const isNew = !existingId;
        try {
            const result = await addRouteSubscription(
                {
                    carrier: oppositeModeMatch.carrier || oppositeModeMatch.carrierId || null,
                    originPort: oppositeModeMatch.originPort || oppositeModeMatch.fromId,
                    destinationPort: oppositeModeMatch.destinationPort || oppositeModeMatch.toId,
                    dischargePort: oppositeModeMatch.dischargePort || oppositeModeMatch.dischargePortId || null,
                    newRoute: isNew,
                    routeSubscriptionId: existingId,
                    isFcl: oppositeModeMatch.isFcl || isFcl,
                    isLcl: oppositeModeMatch.isLcl || isLcl,
                },
                getState
            );
            if (Array.isArray(result) && result[0]) {
                const resolvedId = existingId || result[1];
                // Update Redux: replace the opposite-mode entry with the merged one
                const updatedList = existing.map(item => {
                    const itemId = item.routeSubscriptionId || item.id;
                    const matchId = oppositeModeMatch.routeSubscriptionId || oppositeModeMatch.id;
                    if (matchId && itemId === matchId) {
                        return { ...item, id: resolvedId, isFcl: oppositeModeMatch.isFcl || isFcl, isLcl: oppositeModeMatch.isLcl || isLcl };
                    }
                    // If the opposite item had no id, match by origin/destination/carrier/discharge
                    if (!matchId &&
                        (item.originPort === (oppositeModeMatch.originPort || oppositeModeMatch.fromId)) &&
                        (item.destinationPort === (oppositeModeMatch.destinationPort || oppositeModeMatch.toId)) &&
                        (item.carrier || null) === (oppositeModeMatch.carrier || null) &&
                        (item.dischargePort || null) === (oppositeModeMatch.dischargePort || null)
                    ) {
                        return { ...item, id: resolvedId, isFcl: oppositeModeMatch.isFcl || isFcl, isLcl: oppositeModeMatch.isLcl || isLcl };
                    }
                    return item;
                });
                dispatch({ type: SET_ROUTE_SUBSCRIPTIONS, payload: updatedList });
                return resolvedId;
            }
            return false;
        } catch (error) {
            console.error("Failed to update route subscription", error);
            return false;
        }
    }

    try {
        const result = await addRouteSubscription(
            {
                carrier,
                originPort,
                destinationPort,
                dischargePort,
                newRoute: laneOnlyId ? false : true,
                routeSubscriptionId: laneOnlyId,
                isFcl,
                isLcl,
            },
            getState
        );

        if (Array.isArray(result) && result[0]) {
            return result[1];
        }
        return false;
    } catch (error) {
        console.error("Failed to add route subscription", error);
        return false;
    }
};


export const unsubscribeRouteIfPossible = (matchParams) => async (dispatch, getState) => {
    const { originPort, destinationPort, dischargePort, carrier, routeSubscriptionId, isFcl, isLcl } = matchParams || {};
    const existing = getState()?.route?.routeSubscriptions || [];

    const target = existing.find(item => {
        const originMatch = originPort ? (item.fromId === originPort || item.originPort === originPort) : true;
        const destinationMatch = destinationPort ? (item.toId === destinationPort || item.destinationPort === destinationPort) : true;
        const carrierMatch = item.carrierId || item.carrier ? (item.carrierId === carrier || item.carrier === carrier) : true;
        const dischargeMatch = item.dischargePortId || item.dischargePort ? (item.dischargePortId === dischargePort || item.dischargePort === dischargePort) : true;
        const idMatch = routeSubscriptionId ? (item.routeSubscriptionId === routeSubscriptionId || item.id === routeSubscriptionId) : true;
        const modeMatch = (isFcl == null && isLcl == null) ? true :
            (item.isFcl == null && item.isLcl == null) ? true :
            ((isFcl && item.isFcl === true) || (isLcl && item.isLcl === true));
        return originMatch && destinationMatch && carrierMatch && dischargeMatch && idMatch && modeMatch;
    });

    const idToDelete = routeSubscriptionId || target?.routeSubscriptionId || target?.id;
    if (!idToDelete) return false;
    // If the matched subscription covers both modes and we're only unsubscribing one,
    // update it to strip that mode rather than deleting the whole record.
    if (target?.isFcl === true && target?.isLcl === true && (isFcl != null || isLcl != null)) {
        const updatedIsFcl = isFcl ? false : target.isFcl;
        const updatedIsLcl = isLcl ? false : target.isLcl;
        try {
            const result = await addRouteSubscription(
                {
                    carrier: target.carrier || target.carrierId || null,
                    originPort: target.originPort || target.fromId,
                    destinationPort: target.destinationPort || target.toId,
                    dischargePort: target.dischargePort || target.dischargePortId || null,
                    newRoute: false,
                    routeSubscriptionId: idToDelete,
                    isFcl: updatedIsFcl,
                    isLcl: updatedIsLcl,
                },
                getState
            );
            if (Array.isArray(result) && result[0]) {
                const updated = existing.map(item => {
                    const itemId = item.routeSubscriptionId || item.id;
                    return itemId === idToDelete ? { ...item, isFcl: updatedIsFcl, isLcl: updatedIsLcl } : item;
                });
                dispatch({ type: SET_ROUTE_SUBSCRIPTIONS, payload: updated });
                return idToDelete;
            }
            return false;
        } catch (error) {
            console.error("Failed to update route subscription", error);
            return false;
        }
    }

    try {
        const result = await deleteRouteSubscription(idToDelete, getState);
        if (Array.isArray(result) && result[0]) {
            const updated = existing.filter(item => {
                const itemId = item.routeSubscriptionId || item.id;
                return itemId !== idToDelete;
            });
            dispatch({ type: SET_ROUTE_SUBSCRIPTIONS, payload: updated });
            return idToDelete;
        }
        return false;
    } catch (error) {
        console.error("Failed to delete route subscription", error);
        return false;
    }
};

/**
 * @function
 * @name reset LCL Charges and door locations
 * @description It resets selected card charges and data and door locations.
 * @returns {Redux.Action} The generated action
 */
export const resetAllLclChargesAndDoorLocations = () => (dispatch, getState) => {
    dispatch({ type: RESET_CHARGES, payload: {} });
    dispatch({ type: SET_PICKUP_POSTAL_CODE, payload: "" });
    dispatch({ type: SET_DELIVERY_POSTAL_CODE, payload: "" });
};


/**
 * Stamps each charge array from the external postal/ECU API with a pre-computed
 * totalUsd at index 11.  Rendering code reads index 11 first and skips ECU
 * normalization entirely, so the displayed amount always matches what the API
 * returned for the specific weight / volume in the request.
 *
 * Priority:
 *  1. If the real API already appends totalUsd as a numeric last element (index ≥ 11) → use it.
 *  2. Otherwise compute: max( ratePerUnit * computedQty, minimumUsd ) using calculateLocalCharge
 *     with the weight/volume that was sent in this API call.
 *
 * @param {Array}  charges  - raw charge arrays from the API response
 * @param {number} wtInKG   - metric weight sent in the API call
 * @param {number} volInCBM - metric volume sent in the API call
 */
const enhancePostalApiCharges = (charges, wtInKG, volInCBM) => {
    if (!Array.isArray(charges)) return charges;
    return charges.map((charge) => {
        if (!Array.isArray(charge)) return charge;

        // If the real API already provides a numeric totalUsd as the last element
        const lastEl = charge[charge.length - 1];
        if (typeof lastEl === 'number' && charge.length > 11) {
            const enhanced = [...charge];
            enhanced[11] = lastEl;
            return enhanced;
        }

        // Compute from calculationCode + weight/volume (mock data path)
        const calcCode = charge[10] || charge[6];
        const ratePerUnit = Number(charge[2]) || 0;
        const minimumUsd = Number(charge[4]) || 0;

        let totalUsd;
        if (calcCode) {
            totalUsd = calculateLocalCharge(
                { calculationCode: calcCode, ratePerUnit, minimumUSD: minimumUsd },
                wtInKG || 0,
                volInCBM || 0
            );
        } else {
            totalUsd = Math.max(ratePerUnit, minimumUsd);
        }

        const enhanced = [...charge];
        while (enhanced.length <= 11) enhanced.push(null);
        enhanced[11] = totalUsd;
        return enhanced;
    });
};

export const clearExternalLclCharges = () => ({ type: RESET_CHARGES, payload: { clearApiCharges: true } });

/**
 * Restores all external API charges on every LCL rate card from their stored backups.
 * Called when weight drops back below 3000 kg.
 */
export const restoreExternalLclCharges = () => ({ type: RESTORE_EXTERNAL_LCL_CHARGES, payload: {} });

// Prevent concurrent refetch calls (e.g. weight + volume changing simultaneously)
let refetchLclInFlight = false;

/**
 * Re-fetches live external charges for all LCL rate cards using the current
 * weight/volume and already-stored postal codes.  Makes ONE API request and
 * applies the response to every rate card so nothing is recalculated client-side.
 *
 * @param {Object} lclAirShipment - current shipment object { totalWeight, totalVolume, weightUnit, volumeUnit }
 */
export const refetchExternalLclCharges = (lclAirShipment) => async (dispatch, getState) => {
    if (refetchLclInFlight) return;

    const state = getState();
    const queryParams = state.route.queryParams;
    if (queryParams.type !== 'api-lcl') return;

    const pickupPostalCode = state.route.pickup_postal_code;
    const deliveryPostalCode = state.route.delivery_postal_code;
    if (!pickupPostalCode && !deliveryPostalCode) return;

    const lcl = state.route.seaLCLJSON?.rates?.lcl;
    if (!Array.isArray(lcl) || lcl.length === 0) return;

    refetchLclInFlight = true;
    try {
        const isUserPresent = state.route.USER_DETAILS?.webuser?.userid != null;
        const jwtToken = isUserPresent
            ? state.route.CLIENT_TOKEN?.JWT_TOKEN
            : state.route.JWT_TOKEN?.JWT_TOKEN;

        const transactionType = state.code_config.transactionType;
        const pickupCountryCode = transactionType === 'Importer'
            ? queryParams?.from?.portCode?.substring(0, 2)
            : queryParams?.to?.portCode?.substring(0, 2);
        const deliveryCountryCode = transactionType === 'Importer'
            ? queryParams?.to?.portCode?.substring(0, 2)
            : queryParams?.from?.portCode?.substring(0, 2);

        const convertedShipment = convertToMetric(lclAirShipment);
        const weight = Number(convertedShipment.totalWeight);
        const volume = Number(convertedShipment.totalVolume);

        // Don't refetch when weight exceeds the threshold — clearExternalLclCharges
        // has already cleared the charges and shown the "quote on request" error.
        // Refetching here would repopulate the charges and undo the clear.
        if (weight > 3000) return;

        const etd = new Date(queryParams.date).toISOString().split('T')[0];

        let mode;
        if (pickupPostalCode && deliveryPostalCode) mode = 'pickupDelivery';
        else if (pickupPostalCode) mode = 'pickup';
        else mode = 'delivery';

        let payload = {
            origin: queryParams?.from?.name,
            destination: queryParams?.to?.name,
            validFrom: etd,
            jwtToken,
            volume,
            weight,
            transactionType,
            prepaidCollect: 0,
        };

        if (mode === 'pickup') {
            payload = { ...payload, pickupCountryCode, pickupZipCode: pickupPostalCode };
        } else if (mode === 'delivery') {
            payload = { ...payload, deliveryCountryCode, deliveryZipCode: deliveryPostalCode };
        } else {
            payload = {
                ...payload,
                pickupCountryCode, pickupZipCode: pickupPostalCode,
                deliveryCountryCode, deliveryZipCode: deliveryPostalCode,
            };
        }

        const resultData = await makeGCPRequestForLCLCharges(payload);
        if (!resultData || resultData.status !== 'ok' || !resultData.results) return;

        const data = resultData.results;

        // Stamp index 11 (totalUsd) so the UI's rateItem[11] reads are correct
        const originCharges = Array.isArray(data.originCharges)
            ? enhancePostalApiCharges(data.originCharges, weight, volume)
            : data.originCharges;
        const pickupCharges = Array.isArray(data.pickUpRate)
            ? enhancePostalApiCharges(data.pickUpRate, weight, volume)
            : data.pickUpRate;
        const destinationCharges = Array.isArray(data.destinationCharges)
            ? enhancePostalApiCharges(data.destinationCharges, weight, volume)
            : data.destinationCharges;
        const deliveryCharges = Array.isArray(data.deliveryRate)
            ? enhancePostalApiCharges(data.deliveryRate, weight, volume)
            : data.deliveryRate;
        // Apply fresh charges to every LCL rate card in one pass
        for (const rate of lcl) {
            if (mode === 'pickup' || mode === 'pickupDelivery') {
                if (Array.isArray(originCharges) && originCharges.length) {
                    dispatch(setExternalAPIOriginCharges(rate.id, originCharges, queryParams.type));
                }
                if (Array.isArray(pickupCharges) && pickupCharges.length) {
                    dispatch(setExternalAPIPickupCharges(rate.id, pickupCharges, queryParams.type));
                }
            }
            if (mode === 'delivery' || mode === 'pickupDelivery') {
                if (Array.isArray(destinationCharges) && destinationCharges.length) {
                    dispatch(setExternalAPIDestinationCharges(rate.id, destinationCharges, queryParams.type));
                }
                if (Array.isArray(deliveryCharges) && deliveryCharges.length) {
                    dispatch(setExternalAPIDeliveryCharges(rate.id, deliveryCharges, queryParams.type, false));
                }
            }
        }
    } finally {
        refetchLclInFlight = false;
    }
};

export const setExternalAPIPickupCharges = (id, charges, type, applyToAllMatching) => (
    {
    type: SET_EXTERNAL_API_PICKUP_CHARGES,
    payload: { id, charges, type, applyToAllMatching },
});


export const setExternalAPIDeliveryCharges = (
    id,
    charges,
    type,
    applyToAllMatching = true
) => (
    {
    type: SET_EXTERNAL_API_DELIVERY_CHARGES,
    payload: { id, charges, type, applyToAllMatching },
});

export const setDeliveryAccessorials = (id, accessorials, type, applyToAllMatching) => ({
    type: SET_DELIVERY_ACCESSORIALS,
    payload: { id, accessorials, type, applyToAllMatching },
});

export const setPickupAccessorials = (id, accessorials, type, applyToAllMatching) => ({
    type: SET_PICKUP_ACCESSORIALS,
    payload: { id, accessorials, type, applyToAllMatching },
});

export const setExternalAPIOriginCharges = (id, charges, type) => (
    {
    type: SET_EXTERNAL_API_ORIGIN_CHARGES,
    payload: { id, charges, type },
});

export const setExternalAPIDestinationCharges = (id, charges, type) => (
    {
    type: SET_EXTERNAL_API_DESTINATION_CHARGES,
    payload: { id, charges, type },
});

export const resetExternalAPIPickupAndOriginCharges = (id, type)  => (
    {
        type: RESET_PICKUP_ORIGIN_CHARGES,
        payload: {id, type} ,
});

export const resetExternalAPIDeliveryAndDestinationCharges = (id, type)  => (
    {
        type: RESET_DELIVERY_DESTINATION_CHARGES,
        payload: {id, type} ,
});

export const resetPickupChargesOnly = (id, type) => ({
    type: RESET_PICKUP_CHARGES_ONLY,
    payload: { id, type },
});

export const resetDeliveryChargesOnly = (id, type) => ({
    type: RESET_DELIVERY_CHARGES_ONLY,
    payload: { id, type },
});

export const setPickupPostalCode = (postalCode) => ({
    type: SET_PICKUP_POSTAL_CODE,
    payload: postalCode
});

export const setDeliveryPostalCode = (postalCode) => ({
    type: SET_DELIVERY_POSTAL_CODE,
    payload: postalCode
});

export const setPickupChargeError = (id, errMsg, type) => (
    {
        type: SET_PICKUP_CHARGE_ERROR,
        payload: { id, errMsg, type },
    }
);

export const setDeliveryChargeError = (id, errMsg, type) => (
    {
        type: SET_DELIVERY_CHARGE_ERROR,
        payload: { id, errMsg, type },
    }
);

/**
 * Validates a drayage postal code for either pickup or delivery mode.
 * Checks the country is CA/US, geocodes the zip, and confirms the country matches.
 * Dispatches the appropriate charge error and invokes callback on failure.
 *
 * @returns {Object|null} zipObject on success, null on failure
 */
const validateDrayagePostal = async ({ zipText, countryCode, postalObj, queryParams, mode, dispatch, callback }) => {
    const isNorthAmerica = countryCode === 'CA' || countryCode === 'US';
    const label = mode === 'pickup' ? 'Pickup' : 'Delivery';
    const dispatchChargeError = mode === 'pickup'
        ? (msg) => dispatch(setPickupChargeError(postalObj.itemJsonId, msg, queryParams.type))
        : (msg) => dispatch(setDeliveryChargeError(postalObj.itemJsonId, msg, queryParams.type));

    if (!isNorthAmerica) {
        const message = `${label} charges are not available for the given postal code.`;
        dispatchChargeError(message);
        if (callback) callback(false);
        return null;
    }

    const zipObject = await geocodePostal(zipText);
    // console.log("--- zipObject ---",zipObject)
    if (!zipObject) {
        const message = `${label} charges are not available for the given postal code.`;
        dispatchChargeError(message);
        if (callback) callback(false);
        return null;
    }
    if (zipObject.country && countryCode && zipObject.country !== countryCode) {
        const message = `${label} charges are not available for the given postal code.`;
        dispatchChargeError(message);
        if (callback) callback(false);
        return null;
    }

    return zipObject;
};

/**
 * Executes an FCL drayage API call for either pickup or delivery mode and
 * dispatches the resulting charges and accessorials to Redux.
 *
 * @returns {Object} the (possibly updated) postalObj
 */
async function callFclDrayage({
    mode,
    terminalInput,
    rateInput,
    originType,
    postalObj,
    postalCode,
    queryParams,
    getState,
    dispatch,
    formZipCodeSubmit,
    pickupPostalCode,
    deliveryPostalCode,
    callback,
}) {
    let succeeded = false;

    if (!postalCode) {
        console.log(`No ${mode} postal code present, skipping FCL drayage`);
        dispatch(handleErrorFromAPIResponse(postalObj, mode, queryParams, callback));
        return { postalObj, succeeded };
    }

    const drayageKey = `fcl-${originType}-${mode}-${rateInput.destinationZip}-${rateInput.destinationCity}-${rateInput.destinationState}`;
    if (drayageInFlight.has(drayageKey)) {
        console.log("Duplicate drayage call prevented for:", drayageKey);
        if (callback) callback(false);
        return { postalObj, succeeded };
    }
    drayageInFlight.add(drayageKey);

    try {
        // Clear stale charges immediately so they don't show during the new API call
        if (mode === 'delivery') {
            dispatch(setExternalAPIDeliveryCharges(postalObj.itemJsonId, [], queryParams.type, postalObj?.applyToAllMatching !== false));
            dispatch(setDeliveryAccessorials(postalObj.itemJsonId, [], queryParams.type, postalObj?.applyToAllMatching !== false));
        } else {
            dispatch(setExternalAPIPickupCharges(postalObj.itemJsonId, [], queryParams.type, postalObj?.applyToAllMatching !== false));
            dispatch(setPickupAccessorials(postalObj.itemJsonId, [], queryParams.type, postalObj?.applyToAllMatching !== false));
        }
        const result = await get_fcl_drayage_from_bb(terminalInput, rateInput, getState, dispatch, mode);

        // Discard stale responses: if the user changed the postal code while this call was
        // in-flight, the current postal in Redux will differ from what we sent the request for.
        const currentPostal = mode === 'delivery'
            ? getState().route?.delivery_postal_code
            : getState().route?.pickup_postal_code;
        if (currentPostal !== postalCode) {
            console.log(`Discarding stale FCL drayage response for ${mode} (sent: ${postalCode}, current: ${currentPostal})`);
            if (callback) callback(false);
            return { postalObj, succeeded };
        }

        if (result && result[0] === 200 && result[1]) {
            const rate = result[1];
            const accessorials = result[2] || [];
            if (mode === 'delivery') {
                dispatch(setExternalAPIDeliveryCharges(
                    postalObj.itemJsonId,
                    rate,
                    queryParams.type,
                    postalObj?.applyToAllMatching !== false
                ));
                dispatch(setDeliveryAccessorials(postalObj.itemJsonId, accessorials, queryParams.type, postalObj?.applyToAllMatching !== false));
            } else {
                dispatch(setExternalAPIPickupCharges(postalObj.itemJsonId, rate, queryParams.type, postalObj?.applyToAllMatching !== false));
                dispatch(setPickupAccessorials(postalObj.itemJsonId, accessorials, queryParams.type, postalObj?.applyToAllMatching !== false));
            }

            postalObj.mode = mode;
            postalObj.zipCode = postalCode;
            postalObj = updatePostalObjWithCharges(
                postalObj,
                rate,
                mode === 'delivery' ? 'DELIVERY' : 'PICK UP',
                formZipCodeSubmit,
                pickupPostalCode,
                deliveryPostalCode
            );
            updateJsonAfterPostalSubmit(postalObj, getState, dispatch);
            dispatch(updateErrorAndLoading(undefined, undefined));
            succeeded = true;
        } else {
            if (mode === 'delivery') {
                dispatch(setDeliveryAccessorials(postalObj.itemJsonId, [], queryParams.type, postalObj?.applyToAllMatching !== false));
            } else {
                dispatch(setPickupAccessorials(postalObj.itemJsonId, [], queryParams.type, postalObj?.applyToAllMatching !== false));
            }
        }
    } finally {
        drayageInFlight.delete(drayageKey);
    }

    return { postalObj, succeeded };
};

/**
 * @function
 * @name getJSON
 * @description  it gets remote rate card json for FCL/LCL/AIR mode of transport on search page
 * @param {string | Object} [urlData={}] - either browser url or query params object
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const getJSON =
    (urlData = {}, callback = null) =>
        async (dispatch, getState) => {

            if (isEmpty(getState().code_config.initAuth)) {
                // console.log("session json is empty");
                dispatch(getInitAuth(() => {
                }));
                return;
            }
            // get referral code and type
            if (isEmpty(getState().code_config.referralData)) {
                dispatch(getReferralData());
            }

            // get "req_uuid" and "uuid_verification"
            if (isEmpty(getState().code_config.uuidUrlParamsObj)) {
                dispatch(getUuidUrlParams());
            }

            let queryParams = {};

            //add total_shipment for when air/volume sliders value change
            if (
                isEmpty(urlData) &&
                getState().route.queryParams.type === 'api-air' &&
                !isEmpty(getState().route.airJSON)
            ) {
                // console.log('when air weight changes queryParams');
                queryParams = getState().route.queryParams;
                // console.log('here air queryParams: ', queryParams);
            } else {
                queryParams = !urlData.type ? getQueryParams(urlData) : urlData;

                // console.log('my queryParams: ', queryParams);

                // if queryParams is empty then return
                if (!queryParams || isEmpty(queryParams)) {
                    return;
                }

                // return search mode init reuqest if showForm = true, isFormSubmitSuccess = false
                // it is added here newly
                if (
                    queryParams.showForm &&
                    queryParams.showForm.toLowerCase() === 'true' &&
                    !getState().form.isFormSubmitSuccess
                ) {
                    console.log('return unneccessary rqeuest');
                    return;
                }

                if (queryParams && !queryParams.type) {
                    //set default search type to query params
                    queryParams = {
                        ...queryParams,
                        type: 'api-fcl',
                    };
                }

                dispatch({
                    type: SET_QUERY_PARAMS,
                    payload: queryParams,
                });

                if (
                    !queryParams.from ||
                    isEmpty(queryParams.from) ||
                    !queryParams.to ||
                    isEmpty(queryParams.to)
                ) {
                    console.log('Empty "from" or "to" field');
                    dispatch(
                        updateErrorAndLoading('Empty "from" or "to" field', undefined)
                    );
                    return;
                }

                //set url
                await setURL(dispatch, queryParams);
                // if landing page is used then invoke callback
                // dataPolling is !isLandingPageExist, so !dataPolling is isLandingPageExist
                if (!getState().code_config.dataPolling) {
                    if (callback) callback();
                    return;
                }
            }

            // dispatch(updateErrorAndLoading(undefined, true));

            let form_params;

            try {
                //Search Post request

                let axiosConfig = {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${AUTH_TOKEN}`,
                    },
                };

                let inputParams = {
                    apiKey: API_KEY,
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                    referral_code: getState().code_config.referralData.referral_code,
                    referral_type: getState().code_config.referralData.referral_type,
                    fakNacPercentage: getState()?.route?.fakNacPercent,
                };

                //add google recaptcha res code if showform=false and user is not present
                const {user, verification} = getState().code_config.initAuth;

                const isUserPresent = !!(user && verification);
                if (!getState().form.isFormSubmitSuccess && !isUserPresent) {
                    inputParams.gre_res = getState().code_config.reCaptchaResCode;
                }

                form_params = getSearchBookSaveParams(undefined, getState) || {};
                form_params.type = queryParams.type;

                //only for adding date
                form_params = {
                    ...form_params,
                    pickup: {...form_params.pickup, date: queryParams.date},
                };
                //add total_shipment for air weight change
                if (
                    queryParams.type === 'api-air' &&
                    !isEmpty(getState().route.airJSON)
                ) {
                    // console.log('when air weight changes:', inputParams);
                    form_params = {
                        ...form_params,
                        total_shipment: getState().code_config.airShipment,
                    };
                }

                inputParams = {
                    ...inputParams,
                    form_params,
                };

                dispatch({
                    type: SAVE_SEARCH_FORM_PARAM,
                    payload: {form_params: form_params, show: false},
                });

                // show overlay
                dispatch(setOverlayProgress(0));
                dispatch(setOverlayFullScreen(true));
                let response = {};

                if (getState().route.JWT_TOKEN.JWT_TOKEN === undefined) {
                    await setJWTForRedux(dispatch)
                }

                if(queryParams?.discount){
                    queryParams = {
                        ...queryParams,
                        discount: queryParams?.discount,
                    };
                    dispatch({ type: SET_QUERY_PARAMS, payload: queryParams });
                }
                // add graphql logic here
                let graphql_response_for_rates = {}
                if (getState().route.CLIENT_TOKEN.JWT_TOKEN !== undefined) {
                    console.log(" In Client PORTAL")
                    const result = await get_rate_profile_from_bb(getState);
                    if(result && result[0] === 200 && result[1] && !isEmpty(result[1])){
                        // console.log("=== rate profile data ====",result[1])
                        dispatch(setRateProfile(result[1]))
                    }
                    try{
                        const result = await get_route_subscriptions_from_bb(getState);   
                        if(result && result[0] === 200 && result[1] && Array.isArray(result[1])){
                            // console.log("=== roue subscription data ====",result[1])
                            dispatch(setRouteSubscriptions(result[1]))
                        }
                    }catch(error){
                        console.error("Error while getting route subscriptions: ",error)
                    }
                    graphql_response_for_rates = await get_Client_Rate(getState, inputParams, false, dispatch)
                } else {
                    console.log("Public");
                    graphql_response_for_rates = await get_buying_rate(getState, inputParams, false, dispatch)
                }
                // Smart-picker multi-port handling. Two mutually-exclusive modes, both wrapped so
                // any issue falls through to the original primary response + existing handling:
                //  • PARALLEL merge (REACT_APP_SMART_MULTIPORT=YES): fan ALL candidate lanes out at
                //    once, then merge + source-tag + dedupe the cards into one result set.
                //  • SEQUENTIAL fallback (default): if the nearest lane is empty, try the
                //    next-nearest lane(s) and keep the first that has rates.
                try {
                    if (SMART_MULTIPORT === 'YES') {
                        graphql_response_for_rates = await runMultiPortMerge(
                            getState, dispatch, inputParams, form_params, queryParams, graphql_response_for_rates,
                        );
                    } else if (!responseHasRates(graphql_response_for_rates, queryParams.type)) {
                        const pairs = fallbackLanePairs(getState, queryParams);
                        for (const pair of pairs) {
                            if (!pair.origin || !pair.dest) continue;
                            const fp = {
                                ...form_params,
                                pickup: { ...form_params.pickup, selectedPort: pair.origin },
                                delivery: { ...form_params.delivery, selectedPort: pair.dest },
                            };
                            const ip = { ...inputParams, form_params: fp };
                            const retry = getState().route.CLIENT_TOKEN.JWT_TOKEN !== undefined
                                ? await get_Client_Rate(getState, ip, false, dispatch)
                                : await get_buying_rate(getState, ip, false, dispatch);
                            if (responseHasRates(retry, queryParams.type)) {
                                graphql_response_for_rates = retry;
                                form_params = fp;
                                dispatch({ type: SAVE_SEARCH_FORM_PARAM, payload: { form_params: fp, show: false } });
                                break;
                            }
                        }
                    }
                } catch (fallbackErr) {
                    console.warn('[smart-picker] multi-port handling skipped:', fallbackErr?.message);
                }
                if (graphql_response_for_rates.status !== "200") {
                    const errorMessage = graphql_response_for_rates.error;
                    dispatch(updateErrorAndLoading(errorMessage, undefined));

                    const noRatesForPair =
                        typeof errorMessage === 'string' &&
                        errorMessage.toLowerCase().includes('rates are not available');

                    if (noRatesForPair) {
                        dispatch({
                            type: SAVE_SEARCH_FORM_PARAM,
                            payload: { form_params, show: true },
                        });
                        dispatch({ type: SET_SHOW_RESULT_CARD, payload: true });
                    }
                } else {
                    // reset sidebar services
                    resetSidebarRoleIncoterm(dispatch);
                    if(graphql_response_for_rates.error===undefined) {
                        switch (queryParams.type) {
                            case 'api-fcl':
                                graphql_response_for_rates.response.rates.fcl.forEach((object, index) => {
                                    graphql_response_for_rates.response.rates.fcl[index].blockRoute = false
                                })
                                response.data = graphql_response_for_rates.response
                                response.data = checkFcl45hqPrice(response.data);
                                dispatch({type: SET_SEA_FCL_JSON, payload: response.data});
                                break;
                            case 'api-lcl':
                                graphql_response_for_rates.response.rates.lcl.forEach((object, index) => {
                                    graphql_response_for_rates.response.rates.lcl[index].blockRoute = false
                                })
                                response.data = graphql_response_for_rates.response
                                dispatch({type: SET_SEA_LCL_JSON, payload: response.data});
                                break;
                            case 'api-air':
                                response.data = graphql_response_for_rates.response
                                dispatch({type: SET_AIR_JSON, payload: response.data});
                                break;
                            default:
                                response.data = {};
                                dispatch({type: SET_SEA_FCL_JSON, payload: response.data});
                        }
                    }

                    //set search show blur cards to true
                    dispatch(showSearchBlurCards(true));

                    // reset rate cards state whether cards are expanded or not
                    dispatch(updateRateCardsInfo(null));

                    // update sidebar checkboxes based on all cards
                    updateSidebarRoleIncoterm(response.data, dispatch);

                    // set empty array to old saved zip code array
                    dispatch({type: UPDATE_POSTAL_ZIP_CODE, payload: []});

                    // for data polling
                    // dataPolling is !isLandingPageExist, so !dataPolling is isLandingPageExist
                    if (getState().code_config.dataPolling) {
                        // console.log('should do data polling: ', dataPolling);
                        // get new rate + old rate
                        // await getNewRatesByUUID(queryParams, response.data, dispatch, getState);
                        getNewRatesByUUID(queryParams, response.data, dispatch, getState);

                    }

                    //for contact form
                    let shouldSaveFormParams = false;

                    if (queryParams.type === 'api-fcl') {
                        shouldSaveFormParams =
                            !(response.data &&
                                response.data.rates &&
                                Array.isArray(response.data.rates.fcl) &&
                                response.data.rates.fcl.length !== 0);
                    } else if (queryParams.type === 'api-lcl') {
                        shouldSaveFormParams =
                            !(response.data &&
                                response.data.rates &&
                                Array.isArray(response.data.rates.lcl) &&
                                response.data.rates.lcl.length !== 0);
                    } else if (queryParams.type === 'api-air') {
                        shouldSaveFormParams =
                            !(response.data &&
                                response.data.rates &&
                                Array.isArray(response.data.rates.air) &&
                                response.data.rates.air.length !== 0);
                    }
                    //save old params and show the contact form
                    // shouldSaveFormParams &&
                    dispatch({
                        type: SAVE_SEARCH_FORM_PARAM,
                        payload: {form_params, show: shouldSaveFormParams},
                    });

                    dispatch(updateErrorAndLoading(undefined, undefined));

                    const noRatesReturned =
                        !response.data ||
                        !response.data.rates ||
                        (
                            (!Array.isArray(response.data.rates.fcl) || response.data.rates.fcl.length === 0) &&
                            (!Array.isArray(response.data.rates.lcl) || response.data.rates.lcl.length === 0) &&
                            (!Array.isArray(response.data.rates.air) || response.data.rates.air.length === 0)
                        );

                    dispatch({
                        type: SET_SHOW_RESULT_CARD,
                        payload: isEmpty(response.data),
                    });

                    if (noRatesReturned) {
                        dispatch({
                            type: SAVE_SEARCH_FORM_PARAM,
                            payload: { form_params, show: true },
                        });
                    }

                    //sort or re-sort rates cards upon clicking search btn
                    dispatch({type: RE_SORT_RATE_CARD});

                    // cb
                    if (callback) callback();
                }


            } catch (err) {
                console.log(err);
                const userMessage = err && err.message ? err.message : 'Something went wrong while fetching rates.';
                dispatch(updateErrorAndLoading(userMessage, undefined));

                const userMessageLower = (userMessage || '').toLowerCase();
                const tokenExpired =
                    userMessageLower.includes('token expire') ||
                    userMessageLower.includes('token expired');

                if (tokenExpired) {
                    dispatch({ type: SET_SHOW_RESULT_CARD, payload: true });
                }

                // only show if there is server response
                let seaFCLJSON = getState().route.seaFCLJSON;
                let seaLCLJSON = getState().route.seaLCLJSON;
                let airJSON = getState().route.airJSON;
                if (isEmpty(seaFCLJSON) && isEmpty(seaLCLJSON) && isEmpty(airJSON)) {
                    dispatch({type: SET_SHOW_RESULT_CARD, payload: true});
                }

                //make search form params , show contact form
                dispatch({
                    type: SAVE_SEARCH_FORM_PARAM,
                    payload: { form_params, show: true },
                });

                if (callback) {
                    callback();
                }
            }

            // finalize overlay
            dispatch(setOverlayProgress(100));
            // hide overlay
            dispatch(setOverlayFullScreen(false));
        };


/**
 * @function
 * @name setQueryParams
 * @description  it saves query params in redux store
 * @param {Object} queryParams - query params
 * @returns {Redux.Action} The generated action
 */
export const setQueryParams = (queryParams) => async (dispatch) => {
    dispatch({type: SET_QUERY_PARAMS, payload: queryParams});
};

/**
 * @function
 * @name updateErrorAndLoading
 * @description  it updates error message and spinner loading state
 * @param {string} [error=''] - error message to be shown via in-app notify at bottom-right corner
 * @param {boolean} [loading=false] - whether to show loading spinner
 * @returns {Redux.Action} The generated action
 */
export const updateErrorAndLoading =
    (error = '', loading = false) =>
        async (dispatch) => {
            dispatch({type: UPDATE_ERROR, payload: {error, loading}});
        };

/**
 * @function
 * @name getSearchBookSaveParams
 * @description  it adds pickup and delivery data to an empty object argument
 * @param {Object} [data={}] - empty object
 * @param {Redux.State} getState - whole redux state
 * @returns {Object} it contains pickup and delivery data
 */
const getSearchBookSaveParams = (data = {}, getState) => {
    //add pickup, delivery
    data = {
        ...data,
        pickup: {
            date: getState().route.queryParams.date,
            selectedPort: getState().route.queryParams.from,
        },
        delivery: {
            selectedPort: getState().route.queryParams.to,
        },
    };
    return data;
};

// ── smart-picker sequential nearest-port fallback (Phase 2 #1) ────────────────────
// When a GEO_PLACE pick resolves to several nearby ports, the primary (nearest) lane is
// searched first (unchanged). If it returns no rates, retry the next-nearest candidate
// lane(s) and use the first that has rates. Single-response only — no merging.
const RATE_TYPE_KEY = { 'api-fcl': 'fcl', 'api-lcl': 'lcl', 'api-air': 'air' };

const responseHasRates = (resp, type) => {
    const arr = resp && resp.response && resp.response.rates && resp.response.rates[RATE_TYPE_KEY[type]];
    return resp && resp.status === '200' && Array.isArray(arr) && arr.length > 0;
};

// the full port-list object (has .Name/.Country/coords) for an id, from a side's loaded list
const fullPortById = (ports, id) => (ports || []).find((x) => String(x.id) === String(id)) || null;

// map a full port-list object → the shape a rate query expects on form_params.*.selectedPort
const toSelectedPort = (p) => (p ? {
    id: p.id, name: p.Name, country: p.Country, countryId: p.CountryId,
    linkedPort: p.linkedPort, portLinked: p.portLinked, portCode: p.portCode,
} : null);

// rate-query selectedPort shape for a candidate port id, from the side's loaded port list
const selectedPortById = (ports, id) => toSelectedPort(fullPortById(ports, id));

// nearest-first candidate ports for a side (from the picker), else the single chosen port
const sideCandidatePorts = (picked, ports, chosenPort) => {
    const cands = picked && picked.candidates;
    if (Array.isArray(cands) && cands.length) {
        return cands.map((c) => selectedPortById(ports, c.port && c.port.id)).filter(Boolean);
    }
    return chosenPort ? [chosenPort] : [];
};

// lane pairs to try AFTER the first (already-attempted nearest) pair, nearest-first, capped
const fallbackLanePairs = (getState, queryParams, cap = 4) => {
    const route = getState().route;
    const origins = sideCandidatePorts(queryParams.fromPicked, route.originPortJSON && route.originPortJSON.Ports, queryParams.from);
    const dests = sideCandidatePorts(queryParams.toPicked, route.destinationPortJSON && route.destinationPortJSON.Ports, queryParams.to);
    const pairs = [];
    for (let oi = 0; oi < origins.length; oi++) {
        for (let di = 0; di < dests.length; di++) {
            if (oi === 0 && di === 0) continue; // first/nearest pair already searched
            pairs.push({ origin: origins[oi], dest: dests[di] });
            if (pairs.length >= cap) return pairs;
        }
    }
    return pairs;
};

// ── smart-picker PARALLEL multi-port merge (Phase 2 #1, heavy — flag REACT_APP_SMART_MULTIPORT) ──
// When a pick resolves to several nearby ports, search ALL candidate lanes concurrently and
// merge + source-tag + dedupe the cards into ONE response (vs. the sequential "first lane
// with rates wins" fallback above). Each card carries `_source` so the UI can show "via
// <port>". Off by default — needs HITL on real lanes before cutover.

// distanceKm for a candidate port id on a side, from the picker's slim candidates (else null)
const candidateKm = (picked, id) => {
    const hit = (picked?.candidates || []).find((c) => String(c.port?.id) === String(id));
    return hit?.distanceKm ?? null;
};

// the candidate port ids for a side, nearest-first (else the single chosen port's id)
const sideCandidateIds = (picked, chosen) => {
    const cands = picked?.candidates;
    if (Array.isArray(cands) && cands.length) return cands.map((c) => c.port?.id);
    return chosen ? [chosen.id] : [];
};

// the full candidate port-list objects for a side, nearest-first
const sideCandidateFullPorts = (picked, ports, chosen) =>
    sideCandidateIds(picked, chosen).map((id) => fullPortById(ports, id)).filter(Boolean);

// executor-shaped lane pairs ({origin:{port,distanceKm}, destination:{…}}), nearest-first, capped.
// pair[0] is the primary/nearest lane (its cards are reused from the already-run primary search).
const multiPortLanePairs = (getState, queryParams, cap = 5) => {
    const route = getState().route;
    const origins = sideCandidateFullPorts(queryParams.fromPicked, route.originPortJSON?.Ports, queryParams.from);
    const dests = sideCandidateFullPorts(queryParams.toPicked, route.destinationPortJSON?.Ports, queryParams.to);
    const pairs = [];
    for (const origin of origins) {
        for (const dest of dests) {
            pairs.push({
                origin: { port: origin, distanceKm: candidateKm(queryParams.fromPicked, origin.id) },
                destination: { port: dest, distanceKm: candidateKm(queryParams.toPicked, dest.id) },
            });
            if (pairs.length >= cap) return pairs;
        }
    }
    return pairs;
};

// one lane's rate cards for the active type (or [] if none); a rejection is dropped by the executor
const laneSearcher = (getState, dispatch, inputParams, form_params, type) => async (originPort, destPort) => {
    const fp = {
        ...form_params,
        pickup: { ...form_params.pickup, selectedPort: toSelectedPort(originPort) },
        delivery: { ...form_params.delivery, selectedPort: toSelectedPort(destPort) },
    };
    const ip = { ...inputParams, form_params: fp };
    // no client token → public buying rate; otherwise the client (portal) rate
    const resp = getState().route.CLIENT_TOKEN.JWT_TOKEN === undefined
        ? await get_buying_rate(getState, ip, false, dispatch)
        : await get_Client_Rate(getState, ip, false, dispatch);
    return responseHasRates(resp, type) ? resp.response.rates[RATE_TYPE_KEY[type]] : [];
};

// Fan the picked lane out across all candidate pairs, merge into the base response's
// rates[type] array. Reuses the already-fetched primary cards (no double-fetch) and
// parallel-fetches the rest. Returns the base response unchanged when there's nothing to
// merge (single lane, or no extra rates found), so the caller's downstream is untouched.
const runMultiPortMerge = async (getState, dispatch, inputParams, form_params, queryParams, baseResponse) => {
    const type = queryParams.type;
    const typeKey = RATE_TYPE_KEY[type];
    const pairs = multiPortLanePairs(getState, queryParams);
    if (pairs.length < 2) return baseResponse; // single lane → nothing to merge
    const [primaryPair, ...rest] = pairs;
    const searchLane = laneSearcher(getState, dispatch, inputParams, form_params, type);
    const primaryCards = responseHasRates(baseResponse, type) ? baseResponse.response.rates[typeKey] : [];
    const restResults = await runParallelLaneSearch(rest, searchLane);
    const laneResults = [{ pair: primaryPair, rates: primaryCards }, ...restResults]
        .filter((r) => Array.isArray(r.rates) && r.rates.length);
    const merged = dedupeRates(tagLaneResults(laneResults), structuralRateKey);
    if (!merged.length) return baseResponse;
    const base = baseResponse?.response ? baseResponse : { status: '200', response: { rates: {} } };
    return {
        ...base,
        status: '200',
        response: { ...base.response, rates: { ...base.response.rates, [typeKey]: merged } },
    };
};

// get selectedPort when isFormSubmitSuccess is true
const getFormSelectedPort = (type, getState) => {
    const pickupDeliveryType = getState().form[type][`${type}Type`];
    const isExistingFactorySelected =
        getState().form.factoryInfo[type].isExistingFactorySelected;

    let selectedPort = {};

    if (pickupDeliveryType === 'port') {
        let pickupDeliveryJson = getState().form[type];
        selectedPort = {
            id: pickupDeliveryJson.id,
            country: pickupDeliveryJson.country,
            city: pickupDeliveryJson.city,
        };
    }

    if (pickupDeliveryType === 'factory' && isExistingFactorySelected) {
        let selectedFactoryJson = getState().form[type].selectedExistingFactoryJson;

        if (selectedFactoryJson && !isEmpty(selectedFactoryJson)) {
            if (selectedFactoryJson.port && !isEmpty(selectedFactoryJson.port)) {
                selectedPort = selectedFactoryJson.port;
            }
        }
    }

    // for adding selectedPort to pickup/delivery for new factory type
    if (pickupDeliveryType === 'factory' && !isExistingFactorySelected) {
        selectedPort = getState().form.factoryInfo[type].newFactory.port || {};
    }

    // // for delivery ecommerce and amazon mode, add selected port
    // if (
    //   type === 'delivery' &&
    //   (pickupDeliveryType === 'ecommerce' || pickupDeliveryType === 'amazon')
    // ) {
    //   const ecommAmazonModeKey =
    //     pickupDeliveryType === 'ecommerce' ? 'ecommerceMode' : 'amazonMode';

    //   const selectedFactory = getState().form[type][ecommAmazonModeKey] || {};

    //   const ecommAmazonSelectedJsonKey =
    //     pickupDeliveryType === 'ecommerce'
    //       ? 'selectedEcommerceJson'
    //       : 'selectedAmazonJson';

    //   const selectedFactoryJson =
    //     selectedFactory[ecommAmazonSelectedJsonKey] || {};

    //   if (selectedFactoryJson && !isEmpty(selectedFactoryJson)) {
    //     if (selectedFactoryJson.port && !isEmpty(selectedFactoryJson.port)) {
    //       selectedPort = {
    //         id: selectedFactoryJson.port.id,
    //         country: selectedFactoryJson.port.country,
    //         city: selectedFactoryJson.port.city,
    //       };
    //     }
    //   }
    // }

    // sanitize selected port
    selectedPort = {
        id: selectedPort.id,
        country: selectedPort.country,
        city: selectedPort.city || selectedPort.name,
    };

    return {selectedPort};
};

export const saveBookingFormInfo = (data) => async (dispatch, getState) =>{
    dispatch({
        type: BOOKING_CUSTOMER_FORM,
        payload: data
    })
}

export const getAllAgentProfiles = (isUserPresent) => async (dispatch, getState) => {
    try{
        const response = await getAgentProfilesData(isUserPresent, getState);
        return response
    }catch(error){
        console.error("Error in getting Agent Profiles : ",error)
    }

};

export const getInsuranceQuoteFromAPI = (isUserPresent,insuranceToken, payload, customer ) => async (dispatch,getState) =>{
    // console.log("payload: ",payload)
    try{
        const response = await getCargoInsurance(isUserPresent,insuranceToken, payload, customer, getState);
        // console.log("response", response);
        return response
    }catch(error){
        console.error(error)
    }
}

// Load the Breeze cargo-insurance commodity categories into state.route.commodityList
// — the same source the booking CargoInsurance form uses (get_commodity_list fetches
// the insurance auth token, then the category list). The RFQ creator's insurance
// section reads commodityList; without this it shows "No categories loaded". Idempotent:
// skips the fetch when the list is already in Redux (e.g. loaded by a prior booking).
export const loadCommodityCategoryList = () => async (dispatch, getState) => {
    const existing = getState()?.route?.commodityList;
    if (Array.isArray(existing) && existing.length) return;
    // Offline POC (no Breeze backend / real insurance token) → seed a small bundled
    // category set so the insurance dropdown is testable; the live app fetches the
    // real Breeze categories below. Mirrors the bundled ports.json offline fallback.
    if (process.env.REACT_APP_USE_LOCAL_RATES === 'yes') {
        dispatch({ type: SET_COMMODITY_CATEGORY_LIST, payload: localInsuranceCategoriesJSON });
        return;
    }
    try {
        await get_commodity_list(getState, dispatch);
    } catch (error) {
        console.error(error);
    }
};

// Search the user's Purchase Orders by order number, returning each PO's commodity
// fields (itemDescription / valueOfGoodsUsd / originCountry / currency) so the
// picked PO can populate the customs + insurance commodity rows (#179). Offline
// POC seeds a small bundled set so the import is testable (mirrors the categories
// fallback); the live app queries allPurchaseOrder.
export const searchPurchaseOrders = (searchText) => async (dispatch, getState) => {
    if (process.env.REACT_APP_USE_LOCAL_RATES === 'yes') {
        const q = String(searchText || '').trim().toLowerCase();
        return localPurchaseOrdersJSON.filter(
            (po) => !q || String(po.orderNumbers || '').toLowerCase().includes(q) || String(po.itemDescription || '').toLowerCase().includes(q)
        );
    }
    const st = getState()?.route;
    const isUserPresent = st?.USER_DETAILS?.webuser?.userid != null;
    const jwt = isUserPresent ? st?.CLIENT_TOKEN?.JWT_TOKEN : st?.JWT_TOKEN?.JWT_TOKEN;
    try {
        return await searchPurchaseOrdersDetailed(jwt, searchText);
    } catch (error) {
        console.error(error);
        return [];
    }
};

export const getInsurancePolicyFromAPI = (isUserPresent,insuranceToken, quoteId) => async (dispatch,getState) =>{
    try{
        const response = await getCargoInsurancePolicy(isUserPresent,insuranceToken, quoteId, getState);
        return response
    }catch(error){
        console.error(error)
    }
}

export const revalidate_spot_on_rate = (payload, query_parameter) => async (dispatch, getstate) =>{
    // console.log("---revalidating spot on------------",payload, getstate())
    const userEntityId = getstate()?.route?.USER_DETAILS?.id
    const jwtToken = getstate()?.route?.CLIENT_TOKEN?.JWT_TOKEN

    payload = {
        ...payload,
        // entityId: userEntityId,
        jwtToken: jwtToken
    }

    const computedEtdOrigin =
        payload?.etdOrigin ||
        query_parameter?.etd_origin ||
        (query_parameter?.date
            ? new Date(query_parameter.date).toISOString().split('T')[0]
            : undefined);

    // console.log("query_parameter: ",query_parameter,"computedEtdOrigin: ",computedEtdOrigin)
    const normalizedQueryParams = {
        ...query_parameter,
        etd_origin: computedEtdOrigin,
    };

    // console.log("---payload: ",payload)
    let rates_from_bb = {   
        show_blur_cards: false,
        rates: {
            fcl: [],
            lcl: [],
        },
    };

    //hit the gcp endpoint to get the fresh spotOn rates
    const spotOnData = await makeGCPRequestForFCLExternalRate(payload);
    // console.log("spotOnData: ",spotOnData)
    if(spotOnData && Array.isArray(spotOnData) && spotOnData.length>0){
        for (let pos = 0; pos < spotOnData.length; pos++) {
              let rates_object = spotOnData[pos];
              // console.log("rates_object: ",rates_object)
              let quote_check = rates_object.quote;
              if (rates_object.carrier !== null) {
                await setting_JSON_For_Redux(
                  getstate,
                  rates_object,
                  rates_from_bb,
                  pos,
                  normalizedQueryParams,
                  true,
                  quote_check
                );
              }
        }
        return rates_from_bb;
    }else if(spotOnData && Array.isArray(spotOnData) && spotOnData.length === 0){
        const errorMessage = "Latest cma spot on rate is not available at the moment."
        dispatch(updateErrorAndLoading(`${errorMessage}`, undefined))
    }else{
        const errorMessage = typeof spotOnData === 'string'
          ? spotOnData
          : "cma spot on data is not available at the moment."
        // dispatch(updateErrorAndLoading(`${errorMessage}`, undefined))
        console.log("Message: ",errorMessage)
    }
    // console.log("rates_from_bb: ",rates_from_bb)
}

export const save_final_form = (final_form, isSaveQuoteClicked) => async (dispatch, getState) => {
    dispatch({
        type: FINAL_SEARCH_FORM,
        payload: final_form
    })
    if(isSaveQuoteClicked){
    let jwtToken = getState()?.route?.CLIENT_TOKEN?.JWT_TOKEN
    // console.log("GetState--: ",getState(),"final form: ",final_form);
    const delivery_selected_index = final_form?.selected_card_detail?.delivery_selected_option_index
    const pickup_selected_index = final_form?.selected_card_detail?.pickup_selected_option_index
    let saveQuoteObject={
        carrier: final_form?.selected_card_json?.carrier.id,
        charge_id:final_form?.selected_card_json?.charge_id,
        charge_type_id:final_form?.selected_card_json?.charge_type_id,
        origin_port: getState()?.route?.queryParams?.from?.id,
        destination_port: getState()?.route?.queryParams?.to?.id,
        book_price: final_form?.selected_card_json?.bookNowPrice,
        ETD_origin:final_form?.selected_card_json?.etd_origin,
        discharge_port: final_form?.selected_card_json?.port_of_discharge?.id,
        vessel_service: final_form?.selected_card_json?.vessel_Service?.id,
        validity_from: final_form?.selected_card_json?.valid_date_from,
        validity_to: final_form?.selected_card_json?.valid_date_to,
        isDischargeChecked: final_form?.selected_card_detail?.discharge_isChecked,
        isErsChecked: final_form?.selected_card_detail?.ers_isChecked,
        isFreightChecked: final_form?.selected_card_detail?.frieght_isChecked,
        isPortOriginChecked: final_form?.selected_card_detail?.origin_isChecked,
        isPickupChecked: final_form?.selected_card_detail?.pickup_isChecked,
        isDeliveryChecked: final_form?.selected_card_detail?.delivery_isChecked,
        vendor_contract: final_form?.selected_card_json?.vendor_contract?.id,
        mode_of_transport: final_form?.selected_card_json?.mode,
        spot_rate: final_form?.selected_card_json?.spotRate
    };

    if(final_form.type === "api-lcl"){
        saveQuoteObject= {
            ...saveQuoteObject,
            chargeable_weight: final_form?.chargeableWeight,
            container_type:"LCL",
            freight_rate: Number(final_form?.freightRate)
        }
    }else if(final_form.type === "api-fcl"){
        saveQuoteObject= {
            ...saveQuoteObject,
            _20stWeight:final_form?.selected_card_json?._20stWeight,
            _40stWeight:final_form?.selected_card_json?._40stWeight,
            _40hqWeight:final_form?.selected_card_json?._40hqWeight,
            _45hqWeight:final_form?.selected_card_json?._45hqWeight,
            isOverweight:final_form?.selected_card_json?.isOverweight,
            _20stCounter:final_form?.container?._20stCounter,
            _40hqCounter:final_form?.container?._40hqCounter,
            _40stCounter:final_form?.container?._40stCounter,
            _45hqCounter:final_form?.container?._45hqCounter,
            _20stPrice: (getState().route.discount && getState().route.discount.id) ? (final_form?.selected_card_detail?._20stPrice) : Number(final_form?.selected_card_json?.["20st"]),
            _40hqPrice: (getState().route.discount && getState().route.discount.id) ? (final_form?.selected_card_detail?._40hqPrice) : Number(final_form?.selected_card_json?.["40hq"]),
            _40stPrice: (getState().route.discount && getState().route.discount.id) ? (final_form?.selected_card_detail?._40stPrice) : Number(final_form?.selected_card_json?.["40st"]),
            _45hqPrice: (getState().route.discount && getState().route.discount.id) ? (final_form?.selected_card_detail?._45hqPrice) : Number(final_form?.selected_card_json?.["45hq"]),
            container_type:"FCL"
        }
    }

    const pickupSection = final_form?.selected_card_json?.pickup_section?.[pickup_selected_index] || {}
    const deliverySection= final_form?.selected_card_json?.delivery_section?.[delivery_selected_index] || {}

    let deliveryRateArr =[];
    if(deliverySection && deliverySection.hasOwnProperty("rate") && Array.isArray(deliverySection.rate)){
        deliveryRateArr = final_form?.selected_card_detail?.delivery_charges
    }

    let pickupRateArr =[];
    if(pickupSection && pickupSection.hasOwnProperty("rate") && Array.isArray(pickupSection.rate)){
        pickupRateArr = final_form?.selected_card_detail?.pickup_charges
    }
    const dischargeObject = {
        ers_section: final_form?.selected_card_detail?.ers_charges,
        port_origin_section: final_form?.selected_card_detail?.port_fees_from_charges,
        port_discharge_section: final_form?.selected_card_detail?.port_fees_to_charges,
        pickup_section_charges:pickupRateArr,
        pickup_section : pickupSection,
        delivery_section: deliverySection,
        delivery_section_charges: deliveryRateArr,
        freight_section_charges: final_form?.selected_card_json?.freightCharges,
        // discountID : getState()?.route?.discount?.id,
        discountCode: getState()?.route?.queryParams?.discount
    }
    // Point the rate-card "Save quote" at the CODED saveQuote op (replaces the legacy
    // low-code 4c86ee89). Reuse the data already gathered (saveQuoteObject + the
    // section-charge arrays) to build the normalized input; the pure builder projects
    // it into the { quote, checked, charges, insuranceQuote } shape the op persists.
    const sq = saveQuoteObject;
    const containerType = final_form.type === "api-fcl" ? "FCL" : "LCL";
    const mode = final_form.type === "api-air" ? "AIR" : "OCEAN";
    const fclSizes = containerType === "FCL"
        ? [
            { size: "20", qty: sq._20stCounter, price: sq._20stPrice, weight: sq._20stWeight },
            { size: "40", qty: sq._40stCounter, price: sq._40stPrice, weight: sq._40stWeight },
            { size: "40HQ", qty: sq._40hqCounter, price: sq._40hqPrice, weight: sq._40hqWeight },
            { size: "45", qty: sq._45hqCounter, price: sq._45hqPrice, weight: sq._45hqWeight },
          ]
        : [];
    // Section-charge rows are normalized by the shared adaptSectionCharges (util/saveQuotePayload)
    // — one mapper for both this rate-card save AND the booking-confirmation save. It uses each
    // row's displayed line total + its own chargetype, falling back to the card's freight charge
    // type only when a row carries none. The builder then applies the per-leg TYPE rule (legModes).
    const ct = sq.charge_type_id;
    const ud = getState()?.route?.USER_DETAILS;
    const saveQuoteInput = {
        source: "CARD",
        mode,
        containerType,
        currency: "USD",
        // The logged-in customer's entity owns the saved quote (an RFQ quote links its customer
        // via Rfq; a rate-card quote has no Rfq, so it carries Quote.customer directly).
        // USER_DETAILS IS the customer/company record (has companyName) and USER_DETAILS.id is its
        // entity id — the same value the rest of route_actions reads as `entityId` (e.g. line 660).
        // webuser.entity is null for these logins, so id must come first.
        customerId: ud?.id ?? ud?.webuser?.entity?.id ?? ud?.entity?.id ?? null,
        freightChargeTypeId: sq.charge_type_id,
        carrierId: sq.carrier,
        originPortId: sq.origin_port,
        destPortId: sq.destination_port,
        dischargePortId: sq.discharge_port,
        vesselServiceId: sq.vessel_service,
        vendorContractId: sq.vendor_contract,
        validityFrom: sq.validity_from,
        validityTo: sq.validity_to,
        etdOrigin: sq.ETD_origin,
        isOverweight: sq.isOverweight,
        fclSizes,
        chargeableWeight: sq.chargeable_weight,
        freightRate: sq.freight_rate,
        // LCL/Air metric volume for the Quote header (FCL is container-based → undefined).
        cbm: final_form?.total_shipment?.totalVolume,
        // Transit metadata so the saved quote matches an RFQ-assembly quote (consistency).
        transitTime: final_form?.selected_card_json?.transitTime ?? final_form?.selected_card_json?.schedulesTransitTime,
        totalTransitDays: final_form?.selected_card_json?.transitTime ?? final_form?.selected_card_json?.schedulesTransitTime,
        // Per-leg pricing type (pickup/delivery): RFQ → not saved, ESTIMATE → flagged,
        // INSTANT_RATE → saved normally. Defaults to instant when the card didn't set it.
        legModes: final_form?.legModes || { PICKUP: 'INSTANT_RATE', DELIVERY: 'INSTANT_RATE' },
        // Gate each section by the user's per-section checkbox. The card-detail
        // charge arrays (port fees, drayage) are ALWAYS present, so without this
        // gate an unticked ORIGIN/DELIVERY still fills its bucket and
        // buildSaveQuotePayload's tallyCharges flips checked* true for a section
        // the user never selected. Empty array → empty bucket → checked* stays false.
        sections: {
            ORIGIN: sq.isPortOriginChecked ? adaptSectionCharges(dischargeObject.port_origin_section, ct) : [],
            DESTINATION: sq.isDischargeChecked ? adaptSectionCharges(dischargeObject.port_discharge_section, ct) : [],
            PICKUP: sq.isPickupChecked ? adaptSectionCharges(dischargeObject.pickup_section_charges, ct) : [],
            DELIVERY: sq.isDeliveryChecked ? adaptSectionCharges(dischargeObject.delivery_section_charges, ct) : [],
        },
    };
    try {
        const res = await sendSaveQuote(jwtToken, buildSaveQuotePayload(saveQuoteInput));
        if (res?.ok) {
            dispatch(updateErrorAndLoading('Quote has been saved', undefined));
        } else {
            console.error("saveQuote error:", res?.error);
            dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
        }
    } catch (error) {
        console.error("Error:", error);
        dispatch(updateErrorAndLoading('Error ! Contact Prime Freight', undefined));
    }
}
}

/**
 * @function
 * @name postBookSaveChatUserData
 * @description  it is invoked when booknowprice/chat/savequote button is clicked on a rate card on search page
 * @param {Object} data - selected rate card data
 * @param {boolean} isSaveQuoteClicked - whether save quote button is clicked
 * i.e. `true` - save quote button is clicked, `false` - Book now button is clicked
 * @param {boolean} isChatClicked - whether chat button is clicked
 * (chat button is no longer in use, it was removed, so it's always `false`)
 * @returns {Redux.Action} The generated action
 */
export const postBookSaveChatUserData =
    (data, isSaveQuoteClicked, isChatClicked) => async (dispatch, getState) => {
        try {
            if (getState().form.isFormSubmitSuccess) {
                data.form_params = {};
                if (getState().code_config.showFormCustomService) {
                    data.form_params.customService = getState().form.customService;
                }

                data.form_params.pickup = cleanPickupDeliveryJson(
                    getState,
                    'pickup'
                ).newDataJson;

                data.form_params.delivery = cleanPickupDeliveryJson(
                    getState,
                    'delivery'
                ).newDataJson;

                data.form_params.type = data.type;
                data.form_params.factoryInfo = getState().form.factoryInfo;

                // add total number of overweight containers for FCL
                if (getState().form.isFclTabActive) {
                    data.form_params.overweightContainer =
                        getFclOverweightContainer(getState);
                }
            } else {
                data.form_params = getSearchBookSaveParams({}, getState);
                data.form_params.type = data.type;
                dispatch({
                    type: FINAL_SEARCH_FORM,
                    payload: data
                })
            }

            if (data.type !== 'api-fcl') {
                data.form_params.total_shipment = data.total_shipment;
            } else {
                // TODO- fix isOverweight null in case in Form mode
                const tempContainer = data.container;
                let tempContainerArr = [];
                if (tempContainer._20stCounter) {
                    tempContainerArr.push({
                        input: tempContainer._20stCounter,
                        type: "20'",
                        isOverweight: null,
                    });
                }
                if (tempContainer._40stCounter) {
                    tempContainerArr.push({
                        input: tempContainer._40stCounter,
                        type: "40'",
                        isOverweight: null,
                    });
                }
                if (tempContainer._40hqCounter) {
                    tempContainerArr.push({
                        input: tempContainer._40hqCounter,
                        type: "40'HC",
                        isOverweight: null,
                    });
                }
                if (!REMOVE_FCL_45_HC_CONTAINER && tempContainer._45hqCounter) {
                    tempContainerArr.push({
                        input: tempContainer._45hqCounter,
                        type: "45'HC",
                        isOverweight: null,
                    });
                }
                data.form_params.fclShipping = tempContainerArr;
            }

            if (isSaveQuoteClicked) {
                data.object_type = 'quote_save'; //for quoteSave byn
            } else if (!isSaveQuoteClicked && !isChatClicked) {
                data.object_type = 'shipment_booking'; //for bookNow btn
            }

            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                },
            };
            const tempData = {
                form_params: {...data.form_params, origin: data.origin},
                container: data.container,
                selected_card_json: data.selected_card_json,
                selected_card_detail: data.selected_card_detail,
                zipCodes: data.zipCodes,
                queryParams:getState().route.queryParams,
                jwtToken:getState().route.JWT_TOKEN,
                object_type: data.object_type,
            };
            const params = {
                ...tempData,
                apiKey: API_KEY,
                Authorization: `Bearer ${AUTH_TOKEN}`,
                user: getState().code_config.initAuth.user,
                verification: getState().code_config.initAuth.verification,
                referral_code: getState().code_config.referralData.referral_code,
                referral_type: getState().code_config.referralData.referral_type,
                userEmailBlurCards: getState().cache.userEmailBlurCards,
                agentInfo: getState().form.AgentInformation,
                discount: getState().route.discount
            };

            //console.log('params : ', params);
            //const url = isSaveQuoteClicked ? SAVE_QUOTE_URL : BOOK_NOW_URL;

            // const bookingDataParam = encodeURIComponent(JSON.stringify(params));
            // for booknow only
            // if (!isSaveQuoteClicked) {
            //     // show overlay
            //     dispatch(setOverlayFullScreen(true));
            //     // const href = LANDING_PAGE_SEARCH_CLICK_URL + `landing-page/booking-form?bookingData=${bookingDataParam}`;
            //     // //alert(href);
            //     // Object.assign(document.createElement('a'), {
            //     //   target: '_top', //_self, _blank,   
            //     //   href,
            //     // }).click();
            // } else {
            //     // show only when book now btn is not clicked, other btn are clicked
            //     dispatch(updateErrorAndLoading(undefined, true));
            // }

            // if (isDevENV()) {
            //     await new Promise((resolve) => setTimeout(() => resolve(), 500));
            // }

            // const response = await axios.post(url, {params}, axiosConfig);
            // console.log("response : ", JSON.parse(response.data.data));

            // if (isSaveQuoteClicked) {
            //     // response.data.message = "Your quote has been saved!";
            //     dispatch(
            //         updateErrorAndLoading(
            //             JSON.stringify(response.data.message),
            //             undefined
            //         )
            //     );
            // } else {
            //     if (isDevENV()) {
            //         response.data.redirect_url = 'https://google.com'; //comment this line
            //     }

            //     if (response.data.redirect_url) {
            //         const href = response.data.redirect_url;
            //         const aTag = Object.assign(document.createElement('a'), {
            //             target: shouldRedirectChild() ? '_self' : '_top', //_self, _blank, _top
            //             href,
            //         });
            //         if (!isDevENV()) {
            //             aTag.click();
            //         }
            //     }
            //     dispatch(updateErrorAndLoading(undefined, undefined)); //stop spinning the spin

                //{ "message" :" your quote has been booked. success message",
                //"redirect_url":"https://....."}
            //}
        } catch (err) {
            console.log(err);
            dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
        }
        // finalize overlay if it was shown for booking flow
        dispatch(setOverlayProgress(100));
        dispatch(setOverlayFullScreen(false));
    };

/**
 * @function
 * @name updateShipmentJSON
 * @description  it adds book now price to a rate card json
 * @param {string} id - `id` of a rate card in which book now price will be added in
 * @param {string} bookNowPrice - book now price e.g. `$ 2900.37`
 * @returns {Redux.Action} The generated action
 */
//Route add BOOKNOWPRICE to json
// remove the duplicate json card id
export const updateShipmentJSON =
    (id, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked) => async (dispatch, getState) => {
        let seaFCLJSON = getState().route.seaFCLJSON;
        let seaLCLJSON = getState().route.seaLCLJSON;
        let airJSON = getState().route.airJSON;

        //remove dollar $ sign
        bookNowPrice = parseFloat(bookNowPrice.replace('$', '').trim() || 0);
// console.log('updateShipmentJSON bookNowPrice*********** ', bookNowPrice,discount,"getState().route: ",getState().route);
        // console.log('updateShipmentJSON bookNowPrice*********** ', bookNowPrice);
        // update original saved rate json, add bookNowPrice to it
        updateOriginalRateJson(id, bookNowPrice, pickup_checked, ers_checked,origin_checked, delivery_checked, discharge_checked, getState, dispatch);
        //console.log("...seaFCLJSON: ",seaFCLJSON)
        if (!isEmpty(seaFCLJSON)) {
            const fclArr = seaFCLJSON.rates.fcl.map((element) => {
                let tempEle = {...element};
                // transit time doesn't exist
                if (!tempEle.transit_time) {
                    tempEle = {...tempEle, transit_time: Infinity};
                }
                if (tempEle.id === id) {
                    return {...tempEle, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked};
                }
                return tempEle;
            });
            //console.log("...fclArray: ",fclArr)
            seaFCLJSON = {
                ...seaFCLJSON,
                rates: {...seaFCLJSON.rates, fcl: [...fclArr]},
            };
            dispatch({type: SET_SEA_FCL_JSON, payload: seaFCLJSON});
        }

        if (!isEmpty(seaLCLJSON)) {
            const lclArr = seaLCLJSON.rates.lcl.map((element) => {
                let tempEle = {...element};
                // transit time doesn't exist
                if (!tempEle.transit_time) {
                    tempEle = {...tempEle, transit_time: Infinity};
                }
                if (tempEle.id === id) {
                    return {...tempEle, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked};
                }
                return tempEle;
            });
            seaLCLJSON = {
                ...seaLCLJSON,
                rates: {...seaLCLJSON.rates, lcl: [...lclArr]},
            };
            dispatch({type: SET_SEA_LCL_JSON, payload: seaLCLJSON});
        }

        if (!isEmpty(airJSON)) {
            const airArr = airJSON.rates.air.map((element) => {
                let tempEle = {...element};
                // transit time doesn't exist
                if (!tempEle.transit_time) {
                    tempEle = {...tempEle, transit_time: Infinity};
                }
                if (tempEle.id === id) {
                    return {...tempEle, bookNowPrice, pickup_checked, ers_checked, origin_checked, delivery_checked, discharge_checked};
                }
                return tempEle;
            });
            airJSON = {
                ...airJSON,
                rates: {...airJSON.rates, air: [...airArr]},
            };
            dispatch({type: SET_AIR_JSON, payload: airJSON});
        }
    };

/**
 * @function
 * @name sortCards
 * @description  it sorts rate cards
 * @returns {Redux.Action} The generated action
 */
export const sortCards = () => async (dispatch, getState) => {
    if (getState().route.filterByCheaper) {
        // console.log('im here sortCards: cheaper');
        dispatch(sortByCheaper());
    } else {
        // console.log('im here sortCards: faster');
        dispatch(sortByFaster());
    }
};

// activity-crm PR-2c: the logActivity thunk (client-side SEARCH logging via the
// two legacy BB actions) was removed — rate-api now logs SEARCH server-side from
// the /rate-search payload's `activity` block (attribution + resultsCount,
// ad-block-immune).

export const updateTransitTime = (id, transitTime, type) => ({
    type: UPDATE_TRANSIT_TIME,
    payload: { id, transitTime, type },
});

export const updatePortToPortTransitTime = (id, portTransitTime, type) => ({
    type: UPDATE_PORT_TO_PORT_TRANSIT_TIME,
    payload: { id, portTransitTime, type },
});


export const setSelectedSchedule = (id, schedule, type) => ({
    type: SET_SELECTED_SCHEDULE,
    payload: { id, schedule, type },
});

export const setScheduleId = (id, schedule, local_schedule_key, type ) => ({
    type: SET_SCHEDULE_ID,
    payload: { id, schedule, local_schedule_key, type },
});


export const update_schedule_ids_in_final_form = (id, local_schedule_key, updatedSchedule) => async (dispatch, getState) => {
const currentFinalForm = getState().route?.final_search_form;

if (!currentFinalForm || !currentFinalForm.selected_card_detail) {
    // console.log("⚠️ Cannot update schedule: FINAL_SEARCH_FORM or selected_card_detail is missing.");
    return; // Exit early if state is incomplete
}

const selectedCard = currentFinalForm.selected_card_detail;

// console.log("✅ Attempting to update schedule ID in final form with:",
//     "\nrateId:", id,
//     "\nlocal_schedule_key:", local_schedule_key,
//     "\nselectedCard:", selectedCard
// );

// Only update if IDs match
if (selectedCard.id === id && selectedCard.local_schedule_key === local_schedule_key) {
    const updatedFinalForm = {
    ...currentFinalForm,
    selected_card_detail: {
        ...selectedCard,
        selectedSchedule: updatedSchedule
    }
    };

    dispatch({
    type: FINAL_SEARCH_FORM,
    payload: updatedFinalForm
    });
} else {
    //console.log("🟡 Schedule update skipped: No matching rate or schedule key found.");
}
};
  
/**
 * @function
 * @name setSelectedCarrier
 * @description It sets the selected carrier in [Sidebar]{@Link FCLContainerType}.
 * @param {string} carrier - contains the selected carrier i.g. `{MAERSK}`
 * @returns {Redux.Action} The generated action
 */
export const setSelectedCarrier = (carrier) => ({
    type:  SET_SELECTED_CARRIER,
    payload: carrier
});

/**
 * @function
 * @name setSelectedEtdRangeSchedule
 * @description It sets the selected etd range in [Sidebar].
 * @param {string} etdRange - contains the selected etd range
 * @returns {Redux.Action} The generated action
 */
export const setSelectedEtdRangeSchedule = (etdRange) => ({
    type:  SET_SELECTED_ETD_SCHEDULE,
    payload: etdRange
});

/**
 * @function
 * @name setSelectedEtaRangeSchedule
 * @description It sets the selected eta range in [Sidebar].
 * @param {string} etaRange - contains the selected eta range
 * @returns {Redux.Action} The generated action
 */
export const setSelectedEtaRangeSchedule = (etaRange) => ({
    type:  SET_SELECTED_ETA_SCHEDULE,
    payload: etaRange
});

/**
 * @function
 * @name resetCarrierAndScheduleDateRange
 * @description It resets the selected carrier and schedule etd/eta range [Sidebar].
 * @returns {Redux.Action} The generated action
 */
export const resetCarrierAndScheduleDateRange = () => (dispatch, getState) => {
//   console.log("resetCarrierAndScheduleDateRange ");
  dispatch({ type: SET_SELECTED_CARRIER, payload: "" });
  dispatch({ type: SET_SELECTED_ETD_SCHEDULE, payload: null });
  dispatch({ type: SET_SELECTED_ETA_SCHEDULE, payload: null });
 };

/**
 * @function
 * @name sortByCheaper
 * @description  it sorts rate card by cheaper
 * @returns {Redux.Action} The generated action
 */
export const sortByCheaper = () => async (dispatch, getState) => {
    let seaFCLJSON = getState().route.seaFCLJSON;
    let seaLCLJSON = getState().route.seaLCLJSON;
    let airJSON = getState().route.airJSON;

    // console.log('sortByCheaper ******');

    if (!isEmpty(seaFCLJSON) && seaFCLJSON.rates && !isEmpty(seaFCLJSON.rates)) {
        const fclArr = sortBy(
            seaFCLJSON.rates.fcl,
            (o) => !o.show_variable_rate, // sort card first for variable type then do normal sorting
            'bookNowPrice'
        );
        seaFCLJSON = {
            ...seaFCLJSON,
            rates: {...seaFCLJSON.rates, sort: 'Cheaper', fcl: [...fclArr]},
        };

        dispatch({type: SET_SEA_FCL_JSON, payload: seaFCLJSON});
        // fclArr.map((item) =>
        //   console.log('sortByCheaper price: ', item.bookNowPrice, ' id: ', item.id)
        // );
    }

    if (!isEmpty(seaLCLJSON) && seaLCLJSON.rates && !isEmpty(seaLCLJSON.rates)) {
        const lclArr = sortBy(
            seaLCLJSON.rates.lcl,
            (o) => !o.show_variable_rate, // sort card first for variable type then do normal sorting
            'bookNowPrice'
        );
        seaLCLJSON = {
            ...seaLCLJSON,
            rates: {...seaLCLJSON.rates, sort: 'Cheaper', lcl: [...lclArr]},
        };

        dispatch({type: SET_SEA_LCL_JSON, payload: seaLCLJSON});
    }

    if (!isEmpty(airJSON) && airJSON.rates && !isEmpty(airJSON.rates)) {
        const airArr = sortBy(
            airJSON.rates.air,
            (o) => !o.show_variable_rate, // sort card first for variable type then do normal sorting
            'bookNowPrice'
        );
        airJSON = {
            ...airJSON,
            rates: {...airJSON.rates, sort: 'Cheaper', air: [...airArr]},
        };

        dispatch({type: SET_AIR_JSON, payload: airJSON});
    }

    dispatch({type: SET_FILTER_BY_CHEAPER, payload: true});
};

/**
 * @function
 * @name sortByFaster
 * @description  it sorts rate card by faster
 * @returns {Redux.Action} The generated action
 */
export const sortByFaster = () => async (dispatch, getState) => {
    let seaFCLJSON = getState().route.seaFCLJSON;
    let seaLCLJSON = getState().route.seaLCLJSON;
    let airJSON = getState().route.airJSON;

    // console.log('sortByFaster ******');

    if (!isEmpty(seaFCLJSON) && seaFCLJSON.rates && !isEmpty(seaFCLJSON.rates)) {
        const fclArr = sortBy(seaFCLJSON.rates.fcl,
            (item) => item?.schedules?.portTransitTime ?? item?.schedules?.port_to_port_transit_time);

        seaFCLJSON = {
            ...seaFCLJSON,
            rates: {...seaFCLJSON.rates, sort: 'Faster', fcl: [...fclArr]},
        };
        // console.log(".....seaFCLJSON.....",seaFCLJSON)
        dispatch({type: SET_SEA_FCL_JSON, payload: seaFCLJSON});

        // fclArr.map((item) =>
        //   console.log('sortByFaster price: ', item.bookNowPrice, ' id: ', item.id)
        // );
    }

    if (!isEmpty(seaLCLJSON) && seaLCLJSON.rates && !isEmpty(seaLCLJSON.rates)) {
        const lclArr = sortBy(seaLCLJSON.rates.lcl,
            (item) => item?.schedules?.portTransitTime ?? item?.schedules?.port_to_port_transit_time);
        seaLCLJSON = {
            ...seaLCLJSON,
            rates: {...seaLCLJSON.rates, sort: 'Faster', lcl: [...lclArr]},
        };

        dispatch({type: SET_SEA_LCL_JSON, payload: seaLCLJSON});
    }

    if (!isEmpty(airJSON) && airJSON.rates && !isEmpty(airJSON.rates)) {
        const airArr = sortBy(airJSON.rates.air, [
            'transit_time',
            'bookNowPrice',
        ]);
        airJSON = {
            ...airJSON,
            rates: {...airJSON.rates, sort: 'Faster', air: [...airArr]},
        };

        dispatch({type: SET_AIR_JSON, payload: airJSON});
    }

    dispatch({type: SET_FILTER_BY_CHEAPER, payload: false});
};

const filterByEta = (etaRange, rates) => {
    let filteredArr =[]
    const startDateEta = etaRange?.startOf('week')?.format('DD-MMMM-YYYY');
    const endDateEta = etaRange?.endOf('week')?.format('DD-MMMM-YYYY');
    //console.log("filterRatesByEta.....startDate--", startDateEta,"endDate: ",startDateEta, "etaRange: ",etaRange)

    const startOfWeekEta = startDateEta ? new Date(startDateEta).toISOString().split('T')[0] : null;
    const endOfWeekEta = endDateEta ? new Date(endDateEta).toISOString().split('T')[0] : null;

    if (startOfWeekEta && endOfWeekEta) {
        filteredArr = rates.filter((item) => {
            const etaDestination = item?.schedules?.etaPortOfDestination || item?.schedules?.eta_destination 
            // console.log("etaDestination: ",etaDestination)
            const eta = etaDestination ? new Date(etaDestination)?.toISOString()?.split('T')[0] : null;
            return eta >= startOfWeekEta && eta<=endOfWeekEta;
        });
    }
    return filteredArr
}

const filterByEtd = (etdRange, rates) =>{
    let filteredArr =[]
    const startDateEtd = etdRange?.startOf('week')?.format('DD-MMMM-YYYY');
    const endDateEtd = etdRange?.endOf('week')?.format('DD-MMMM-YYYY');
    //console.log("filterRatesByEta.....startDate--", startDateEtd,"endDate: ",endDateEtd, "etdRange: ",etdRange)
    const startOfWeekEtd = startDateEtd ? new Date(startDateEtd).toISOString().split('T')[0] : null;
    const endOfWeekEtd = endDateEtd ? new Date(endDateEtd).toISOString().split('T')[0] : null;
    if (startOfWeekEtd && endOfWeekEtd) {
        filteredArr = rates.filter((item) => {
            const etd = item.schedules && (item?.schedules?.etd) ? new Date(item.schedules.etd).toISOString().split('T')[0] : null;
            // console.log("----schedule etd----- ",etd, 
            //     "etd >= startOfWeek && etd<=endOfWeek",etd >= startOfWeekEtd && etd<=endOfWeekEtd)
            if (etd) {
                return etd >= startOfWeekEtd && etd <= endOfWeekEtd;
            }
            return false; // If etd is not defined, do not include this item
        });
    }
    return filteredArr
}

const filterDataByRange = (etaRange, etdRange, rates, selected_carrier = undefined) =>{
    let filteredJsonArr = []
    if(etaRange && etdRange){
        // console.log("---both etd and eta range are present")
        const filterdEtdRates = filterByEtd(etdRange, rates);
        // console.log("filtered rates by ETD: ",filterdEtdRates);
        const filteredEtaRates = filterByEta(etaRange, filterdEtdRates);
        // console.log("filtered rates by ETA...",filteredEtaRates)
        filteredJsonArr = filteredEtaRates

    }else if(etaRange && !etdRange){
        // console.log("---only etaRange is present----")
        const filterdEtaRates = filterByEta(etaRange, rates);
        // console.log("filterdEtaRates: ",filterdEtaRates)
        filteredJsonArr = filterdEtaRates
    }else if(!etaRange && etdRange){
        // console.log("---only etdRange is present-----")
        const filterdEtdRates = filterByEtd(etdRange, rates);
        // console.log("filterdEtdRates: ",filterdEtdRates)
        filteredJsonArr = filterdEtdRates
    }else if(!etaRange && !etdRange && selected_carrier !== ""){
        // console.log("---both etd and eta range are not present or null")
        filteredJsonArr = rates
    }else if(!etaRange && !etdRange && selected_carrier === ""){
        filteredJsonArr = rates
    }
    return filteredJsonArr;
}

export const filterRatesByEtaEtd = (etaRange, etdRange, selected_carrier) => async (dispatch, getState) => {
    // console.log("filterRatesByEtaEtd is executing......",etaRange,etdRange, selected_carrier)
    let seaFCLJSON = getState().route.seaFCLJSON;
    let seaLCLJSON = getState().route.seaLCLJSON;
    let airJSON = getState().route.airJSON;
    // console.log('sortByFaster ******');
    if (!isEmpty(seaFCLJSON) && seaFCLJSON.rates && !isEmpty(seaFCLJSON.rates)) {
        let fclRates = seaFCLJSON?.rates?.fcl
        // let rates = fclRates;
        const filteredJsonArr = filterDataByRange(etaRange, etdRange, fclRates, selected_carrier)
        // console.log("filteredJsonArr: ",filteredJsonArr)
            // If you want to update the state with filtered results
        seaFCLJSON = {
            ...seaFCLJSON,
            rates: {
                ...seaFCLJSON.rates,
                filteredJson: [...filteredJsonArr],  // Add the filtered fcl array to the rates object
            },
        };
        // Dispatch the updated seaFCLJSON to the store
        dispatch({
            type: 'SET_SEA_FCL_JSON',  // Action type
            payload: seaFCLJSON,       // Payload is the updated seaFCLJSON with filtered rates
        });
        return filteredJsonArr;
    }

    //console.log("---filterRatesByEtaEtd is executing.....",etaRange, etdRange)
    if (!isEmpty(seaLCLJSON) && seaLCLJSON.rates && !isEmpty(seaLCLJSON.rates)) {
        let lclRates = seaLCLJSON?.rates?.lcl
        // let rates = fclRates;
        const filteredJsonArr = filterDataByRange(etaRange, etdRange, lclRates)
        // console.log("filteredJsonArr: ",filteredJsonArr)
            // If you want to update the state with filtered results
            seaLCLJSON = {
            ...seaLCLJSON,
            rates: {
                ...seaLCLJSON.rates,
                filteredJson: [...filteredJsonArr],  // Add the filtered fcl array to the rates object
            },
        };

        dispatch({type: SET_SEA_LCL_JSON, payload: seaLCLJSON});
        return filteredJsonArr;
    }

    if (!isEmpty(airJSON) && airJSON.rates && !isEmpty(airJSON.rates)) {
        let airRates = airJSON?.rates?.air
        // let rates = fclRates;
        const filteredJsonArr = filterDataByRange(etaRange, etdRange, airRates, selected_carrier)
            // If you want to update the state with filtered results
            airJSON = {
            ...airJSON,
            rates: {
                ...airJSON.rates,
                filteredJson: [...filteredJsonArr],  // Add the filtered fcl array to the rates object
            },
        };

        dispatch({type: SET_AIR_JSON, payload: airJSON});
        return filteredJsonArr;
    }

};
/**
 * @function
 * @name API_Call_For_JWT
 * @description  it gets public JWT token from bettyblocks
 * @returns {Redux.Action} The generated action JWT
 */
const API_Call_For_JWT = async (LOGIN_URL) => {
    // for production environment
    if (!isDevENV()) {
        return await axios.post(LOGIN_URL).then(res => {
            return res.data
        }).catch(err => {
            console.error(err)
        })
    } else {
        return await axios.post(LOGIN_URL).then(res => {
            return res.data.data
        }).catch(err => {
            console.error(err)
        })
    }


}

export const getJWTForAgent = () => async (dispatch, getState) => {
    //  Getting JWT token from betty blocks for graphql
    if (getState().route.JWT_TOKEN.JWT_TOKEN === undefined) {
        //console.log("JWT_TOKEN is undefined...",getState().route.JWT_TOKEN.JWT_TOKEN)
        await setJWTForRedux(dispatch)
    }
}
/**
 * @function
 * @name getRemotePortsJson
 * @description  it gets origin and destination ports json from remote server for custom ports dropdown
 * @returns {Redux.Action} The generated action
 */
export const getRemotePortsJson = () => async (dispatch, getState) => {
    let queryParams = getQueryParams(window.location.href);


    try {
        // let axiosConfig = {
        //   headers: {
        //     'Content-Type': 'application/json',
        //     Authorization: `Bearer ${AUTH_TOKEN}`,
        //     jsessionid: getState().code_config.initAuth,
        //   },
        // };
        // const inputParams = {
        //   apiKey: API_KEY,
        //   Authorization: `Bearer ${AUTH_TOKEN}`,
        //   user: getState().code_config.initAuth.user,
        //   verification: getState().code_config.initAuth.verification,
        // };

        // when iframe==yes and show form==yes and token is present
        // if(queryParams.iframe!==undefined && queryParams.iframe!==false && queryParams.token!==undefined){
        //  return ;
        // }

        dispatch(updateErrorAndLoading(undefined, true));

        //  Getting JWT token from betty blocks for graphql
        if (getState().route.JWT_TOKEN.JWT_TOKEN === undefined) {
            await setJWTForRedux(dispatch)
        }

        // Fetch destination charges once at app start
        if (!getState().route.defaultDestinationCharges || getState().route.defaultDestinationCharges.length === 0) {
            dispatch(getDestinationCharges());
        }

        // to map Origin Port from betty blocks through Graphql
        if (getState().originPortJSON === undefined && getState().destinationPortJSON === undefined) {
            let graph_ql_response = await get_all_ports_from_db(getState);

            if (graph_ql_response.status !== "200") {
                dispatch(
                    updateErrorAndLoading(graph_ql_response.error, undefined)
                );
            } else {
                dispatch({
                    type: SET_PORT_ORIGIN_JSON,
                    payload: graph_ql_response.response.port_origin,
                });

                dispatch({
                    type: SET_PORT_DESTINATION_JSON,
                    payload: graph_ql_response.response.port_destination,
                });
            }

            await get_commodity_list(getState,dispatch);
            
        }

    } catch (err) {
        console.log(err);
        dispatch(
            updateErrorAndLoading(
                JSON.stringify(err.message) + ', error in getting Ports',
                undefined
            )
        );
    }
};

const updatePostalObjWithCharges = (postalObj, rate, description, formZipCodeSubmit, pickupPostalCode, deliveryPostalCode) => {
    let responseData = {};
    if(postalObj?.mode === "pickup" //|| description === "PICK UP"
    ){
        const useOptionName = postalObj?.optionMode === "pickup";
        const baseName = (useOptionName && postalObj?.option?.name) || "Pickup";
        responseData = {
            name: baseName,
            rate,
            currency: "USD",
            description,
            fetch_zip_code: postalObj?.option?.fetch_zip_code ?? true,
        };
    }else if (postalObj?.mode === "delivery"  //|| description === "DELIVERY"
    ){
        const useOptionName = postalObj?.optionMode === "delivery";
        const baseName = (useOptionName && postalObj?.option?.name) || "To Door Delivery";
        responseData = {
            name: baseName,
            rate,
            currency: "USD",
            description,
            fetch_zip_code: postalObj?.option?.fetch_zip_code ?? true,
        };
    }

    return {
        ...postalObj,
        option: responseData && !isEmpty(responseData) ? responseData : {},
        ...(formZipCodeSubmit && { formZipCodeSubmit }), // Add formZipCodeSubmit if necessary
    };
};

export const postDoorLocationData = (postalObj, lclAirShipment, mode, callback = undefined, formZipCodeSubmit = undefined, cancelToken,
    ) => async (dispatch, getState) => {
        
        // Create a unique key for this request
        const originTypeKey = postalObj?.ersChecked ? 'rail' : 'marine';
        const cacheKey =
            postalObj?.applyToAllMatching && postalObj?.mode === 'delivery'
                ? `${postalObj.mode}-${postalObj.zipCode}-${originTypeKey}`
                : `${postalObj.itemJsonId}-${postalObj.mode}-${postalObj.zipCode}-${postalObj.uuid}`;
        const now = Date.now();
        
        // Check if we've made this exact call recently (within 1 second)
        if (postDoorLocationDataCache.has(cacheKey)) {
            const lastCallTime = postDoorLocationDataCache.get(cacheKey);
            if (now - lastCallTime < 1000) { // 1 second debounce
                // console.log("Duplicate call prevented for:", cacheKey);
                return;
            }
        }
        
        // Store this call in cache
        postDoorLocationDataCache.set(cacheKey, now);
        
        // Clean up old cache entries (older than 5 seconds)
        for (const [key, time] of postDoorLocationDataCache.entries()) {
            if (now - time > 5000) {
                postDoorLocationDataCache.delete(key);
            }
        }
        
        if (mode === "delivery") {
            dispatch({ type: SET_DELIVERY_DRAYAGE_LOADING, payload: true });
        }
        try {
        let pickupPostalCode = getState().route?.pickup_postal_code
        let deliveryPostalCode = getState().route?.delivery_postal_code
        let queryParams = getState().route.queryParams;
        const isUserPresent =  getState()?.route?.USER_DETAILS?.webuser?.userid != null
        let jwtToken;
        if(isUserPresent){
            jwtToken = getState().route.CLIENT_TOKEN.JWT_TOKEN;
        }else{
            jwtToken = getState().route.JWT_TOKEN.JWT_TOKEN
        }

        const transactionType = getState().code_config.transactionType
        const pickupCountryCode = queryParams?.from?.portCode?.substring(0, 2);
        const deliveryCountryCode = queryParams?.to?.portCode?.substring(0, 2);
        if(queryParams.type === 'api-fcl'){
            // console.log("transactionType: ",transactionType, "mode: ", mode,
            //     "pickupCountryCode: ",pickupCountryCode, "deliveryCountryCode: ",deliveryCountryCode,
            //     "postal object: ",postalObj
            // )
            let originType = "marine";
            if(postalObj?.ersChecked){
                originType = "rail"
            }
            const originCityName = postalObj?.origin?.selectedPort
            const originCountryName = postalObj?.origin?.country
            const originStateCode = findStateCodeByCityAndCountryName(originCityName, originCountryName);
            //console.log("originCityName: ",originCityName,"originCountryName: ",originCountryName,"originStateCode: ",originStateCode);

            const cityName = postalObj?.destination?.selectedPort
            const countryName = postalObj?.destination?.country
            // console.log("cityName: ",cityName,"countryName: ",countryName);
            const stateCode = findStateCodeByCityAndCountryName(cityName, countryName);
            // console.log("given cityName: ",cityName,"given countryName: ",countryName,"stateCode: ",stateCode);
        
            const zipText = (postalObj?.zipCode || '').trim();

            if(isUserPresent){
                jwtToken = getState().route.CLIENT_TOKEN.JWT_TOKEN;
            }else{
                jwtToken = getState().route.JWT_TOKEN.JWT_TOKEN;
            }
            let rateInput = {}, terminalInput = {}
            if (mode === "pickup"){
                const zipObject = await validateDrayagePostal({
                    zipText,
                    countryCode: pickupCountryCode,
                    postalObj,
                    queryParams,
                    mode,
                    dispatch,
                    callback,
                });
                if (!zipObject) return [400, [], "Pickup drayage is not available for the given location"];
                rateInput = {
                    originType: originType,
                    // destinationCity: zipObject.city,
                    destinationCity: (zipObject.country === pickupCountryCode && (zipObject.city || originCityName)),
                    destinationState: zipObject?.state || originStateCode,
                    destinationZip: postalObj?.zipCode?.toUpperCase(),
                }
                terminalInput = {
                    city: originCityName,
                    state: originStateCode,
                    type: originType
                }
            }else if (mode === "delivery"){
                const zipObject = await validateDrayagePostal({
                    zipText,
                    countryCode: deliveryCountryCode,
                    postalObj,
                    queryParams,
                    mode,
                    dispatch,
                    callback,
                });
                if (!zipObject) return [400, [], "Delivery charge is not available for the given location"];
                rateInput = {
                    originType: originType,
                    // destinationCity: zipObject.city,
                    destinationCity: (zipObject.country === deliveryCountryCode && (zipObject.city || cityName)),
                    destinationState: zipObject?.state || stateCode,
                    destinationZip: postalObj?.zipCode?.toUpperCase(),
                }
                terminalInput = {
                    city: cityName,
                    state: stateCode,
                    type: originType
                }
            }
            
            // Validate inputs before calling drayage function
            if (!terminalInput.city || !terminalInput.state || !terminalInput.type) {
                const message = "Unable to calculate drayage: terminal information is incomplete.";
                // dispatch(setDeliveryChargeError(postalObj.itemJsonId, message, queryParams.type));
                dispatch(updateErrorAndLoading(message, undefined));
                if (callback) callback(false);
                return;
            }
            if (!rateInput.destinationCity || !rateInput.destinationState || !rateInput.destinationZip) {
                const message = "Unable to calculate drayage: destination information is incomplete.";
                // dispatch(setDeliveryChargeError(postalObj.itemJsonId, message, queryParams.type));
                dispatch(updateErrorAndLoading(message, undefined));
                if (callback) callback(false);
                return;
            }

            // Compute opposite-type cards for the auto-fetch below.
            // We do NOT pre-clear them here — RESET_DELIVERY/PICKUP_CHARGES_ONLY already
            // wipes all FCL cards when the user changes location, so clearing again before
            // the dedup check in callFclDrayage would erase valid charges that were just
            // set, causing the "To Door Delivery" section to flash and re-fetch unnecessarily.
            const oppositeOriginType = originType === 'rail' ? 'marine' : 'rail';
            const fclRatesSnapshot = getState()?.route?.seaFCLJSON?.rates?.fcl || [];
            const oppositeTypeCards = fclRatesSnapshot.filter(
                rate => (rate.ers_checked ? 'rail' : 'marine') === oppositeOriginType
            );

            const primaryResult = await callFclDrayage({
                mode,
                terminalInput,
                rateInput,
                originType,
                postalObj,
                postalCode: mode === 'delivery' ? deliveryPostalCode : pickupPostalCode,
                queryParams,
                getState,
                dispatch,
                formZipCodeSubmit,
                pickupPostalCode,
                deliveryPostalCode,
                callback,
            });
            postalObj = primaryResult.postalObj;

            // Auto-fetch drayage for the opposite origin type (rail ↔ marine) if those cards exist,
            // so the user does not have to manually submit the postal for each card type.
            // Only triggered when the primary call actually dispatched charges — dedup hits,
            // missing postal, stale responses, and non-200s should not kick off a second round-trip.
            // oppositeOriginType and oppositeTypeCards were already computed above.
            if (primaryResult.succeeded && oppositeTypeCards.length > 0) {
                const oppositeCard = oppositeTypeCards[0];
                const oppositePostalObj = {
                    ...postalObj,
                    itemJsonId: oppositeCard.id,
                    ersChecked: oppositeCard.ers_checked,
                    applyToAllMatching: true,
                };
                const oppositeTerminalInput = { ...terminalInput, type: oppositeOriginType };
                const oppositeRateInput = { ...rateInput, originType: oppositeOriginType };
                callFclDrayage({
                    mode,
                    terminalInput: oppositeTerminalInput,
                    rateInput: oppositeRateInput,
                    originType: oppositeOriginType,
                    postalObj: oppositePostalObj,
                    postalCode: mode === 'delivery' ? deliveryPostalCode : pickupPostalCode,
                    queryParams,
                    getState,
                    dispatch,
                    formZipCodeSubmit: undefined,
                    pickupPostalCode,
                    deliveryPostalCode,
                    callback: undefined,
                });
            }
        }else{
            //in case volume is in CFT or weight is in LB
            const convertedLclShipment = convertToMetric(lclAirShipment);
            // console.log("converted lclShipment: ",convertedLclShipment);
        
            const weight = Number(convertedLclShipment.totalWeight)
            const volume = Number(convertedLclShipment.totalVolume)
            // console.log("--lclAirShipment----: ",lclAirShipment)
            const etd =  (new Date(queryParams.date)).toISOString().split('T')[0]; 
            let prepaidCollect = 0;
            let originCharges, pickUpRate, destinationCharges, deliveryRate;

            if(postalObj?.prepaidCollect && postalObj.prepaidCollect === "collect"){
                // console.log("----prepaid collect paaram is prsent....");
                prepaidCollect = 1;
            }
        
            let payload = {
                origin: queryParams?.from?.name,
                destination: queryParams?.to?.name,
                validFrom: etd,
                jwtToken: jwtToken,
                volume: volume,
                weight: weight,
                transactionType: transactionType,
                prepaidCollect: prepaidCollect
            }

            if(mode === "pickup"){
                payload = {
                    ...payload,
                    pickupCountryCode: pickupCountryCode,
                    pickupZipCode: pickupPostalCode,
                }

            }else if (mode === "delivery"){
                payload = {
                    ...payload,
                    deliveryCountryCode: deliveryCountryCode,
                    deliveryZipCode: deliveryPostalCode,
                }

            }else if(mode === "pickupDelivery"){
                payload = {
                    ...payload,
                    pickupCountryCode: pickupCountryCode,
                    pickupZipCode: pickupPostalCode,
                    deliveryCountryCode: deliveryCountryCode,
                    deliveryZipCode: deliveryPostalCode,
                }
            }
            // console.log("----gievn payload----------",payload)
            const resultData = await makeGCPRequestForLCLCharges(payload);
            if(resultData?.status === "error"){
                const message = resultData?.error
                dispatch(updateErrorAndLoading(message, undefined));
            }

            if(resultData && resultData?.status === "ok" && resultData?.results && !isEmpty(resultData?.results)){
                const data = resultData?.results
                // console.log("---data-----",data)
                if(mode === "pickup"){
                    originCharges = enhancePostalApiCharges(data?.originCharges, weight, volume)
                    pickUpRate = enhancePostalApiCharges(data?.pickUpRate, weight, volume)
                    // console.log("----filteredOriginDetails----",originCharges, "pickup rate: ",pickUpRate);
                    dispatch(setExternalAPIOriginCharges(postalObj.itemJsonId, originCharges, queryParams.type))
                    dispatch(setExternalAPIPickupCharges(postalObj.itemJsonId, pickUpRate, queryParams.type))
        
                    if(!pickUpRate || pickUpRate.length === 0){
                        const message = "Pick up charges are not available for the given postal code."
                        //dispatch error msg for pickup row
                        dispatch(setPickupChargeError(postalObj.itemJsonId, message, queryParams.type))
                    }
        
                    postalObj = updatePostalObjWithCharges(postalObj, pickUpRate, "PICK UP", formZipCodeSubmit, pickupPostalCode, deliveryPostalCode);
                    // console.log("---postalObj---",postalObj)
                    updateJsonAfterPostalSubmit(postalObj, getState, dispatch);
                    dispatch(updateErrorAndLoading(undefined, undefined));
        
                }else if(mode === "delivery"){
                    destinationCharges = enhancePostalApiCharges(data?.destinationCharges, weight, volume)
                    deliveryRate = enhancePostalApiCharges(data?.deliveryRate, weight, volume)
                    //console.log("postalObj.itemJsonId",postalObj.itemJsonId,"-----destinationCharges: ",destinationCharges,"queryParams.type: ",queryParams.type)
                    if(destinationCharges && Array.isArray(destinationCharges) && destinationCharges.length>0){
                        dispatch(setExternalAPIDestinationCharges(postalObj.itemJsonId, destinationCharges,queryParams.type))
                    }
                    // console.log("---delivery rate-----",deliveryRate)
                    dispatch(setExternalAPIDeliveryCharges(
                        postalObj.itemJsonId,
                        deliveryRate,
                        queryParams.type,
                        postalObj?.applyToAllMatching !== false
                    ))
        
                    if(!deliveryRate || deliveryRate.length === 0){
                        const message = "Delivery charges are not available for the given postal code."
                        //dispatch error msg for delivery row
                        dispatch(setDeliveryChargeError(postalObj.itemJsonId, message, queryParams.type));
                    }
        
                    postalObj = updatePostalObjWithCharges(postalObj, deliveryRate, "DELIVERY", formZipCodeSubmit, pickupPostalCode, deliveryPostalCode);
                    updateJsonAfterPostalSubmit(postalObj, getState, dispatch);
                    dispatch(updateErrorAndLoading(undefined, undefined));
        
                }else if( mode === "pickupDelivery"){
                    // Save original option before pickup sub-call overwrites postalObj.option.
                    // Without this, the delivery sub-call reads postalObj.option.name = "Pickup"
                    // (the fallback set when optionMode !== 'pickup') and labels the delivery
                    // radio button as "Pickup".
                    const originalOption = postalObj.option;

                    originCharges = enhancePostalApiCharges(data?.originCharges, weight, volume)
                    pickUpRate = enhancePostalApiCharges(data?.pickUpRate, weight, volume)
                    // console.log("----filteredOriginDetails----",originCharges);
                    dispatch(setExternalAPIOriginCharges(postalObj.itemJsonId, originCharges,queryParams.type))
                    dispatch(setExternalAPIPickupCharges(postalObj.itemJsonId, pickUpRate, queryParams.type))
                    postalObj.mode = "pickup"
                    postalObj.zipCode = pickupPostalCode
                    postalObj = updatePostalObjWithCharges(postalObj, pickUpRate, "PICK UP", formZipCodeSubmit, pickupPostalCode, deliveryPostalCode);

                    updateJsonAfterPostalSubmit(postalObj, getState, dispatch);
                    dispatch(updateErrorAndLoading(undefined, undefined));

                    destinationCharges = enhancePostalApiCharges(data?.destinationCharges, weight, volume)
                    deliveryRate = enhancePostalApiCharges(data?.deliveryRate, weight, volume)
                    //console.log("postalObj.itemJsonId",postalObj.itemJsonId,"-----destinationCharges: ",destinationCharges,"queryParams.type: ",queryParams.type)
                    if(destinationCharges && Array.isArray(destinationCharges) && destinationCharges.length>0){
                        dispatch(setExternalAPIDestinationCharges(postalObj.itemJsonId, destinationCharges, queryParams.type))
                    }
                    dispatch(setExternalAPIDeliveryCharges(
                        postalObj.itemJsonId,
                        deliveryRate,
                        queryParams.type,
                        postalObj?.applyToAllMatching !== false
                    ))
                    postalObj.mode = "delivery"
                    // Restore original option so the delivery sub-call uses the correct delivery
                    // option name instead of the "Pickup" fallback written by the pickup sub-call.
                    postalObj.option = originalOption;
                    postalObj.zipCode = deliveryPostalCode
                    postalObj = updatePostalObjWithCharges(postalObj, deliveryRate, "DELIVERY", formZipCodeSubmit, pickupPostalCode, deliveryPostalCode);
                    updateJsonAfterPostalSubmit(postalObj, getState, dispatch);
                    dispatch(updateErrorAndLoading(undefined, undefined));
                }
        
            }else{
                // console.log("No quote present for the given location....", getState());
                dispatch(handleErrorFromAPIResponse(postalObj, mode, queryParams, callback))
            }
            
        }   
        // console.log("postalObj: ",postalObj)
        // updateJsonAfterPostalSubmit(postalObj, getState, dispatch);
        // dispatch(updateErrorAndLoading(undefined, undefined));
        if (callback) {
            callback(true);
        }
        } finally {
            if (mode === "delivery") {
                dispatch({ type: SET_DELIVERY_DRAYAGE_LOADING, payload: false });
            }
            if (callback) callback(false);
        }
}

const handleErrorFromAPIResponse = (postalObj, mode, queryParams, callback) => async (dispatch, getState) => {
    const seaLclJson = getState()?.route?.seaLCLJSON?.rates?.lcl
    const matchingObject = seaLclJson?.find(item => 
        item.id === postalObj.itemJsonId && item.uuid === postalObj.uuid
    );
    if(mode === "pickup"){
        // console.log("pickup........")
        const message = "Pick up charges are not available for the given postal code."
        dispatch(setPickupChargeError(postalObj.itemJsonId, message, queryParams.type))
        dispatch(resetExternalAPIPickupAndOriginCharges(postalObj.itemJsonId,queryParams.type))
    }else if(mode === "delivery"){
        // console.log("delivery........")
        const message = "Delivery charges are not available for the given postal code."
        dispatch(setDeliveryChargeError(postalObj.itemJsonId, message, queryParams.type))
        dispatch(resetExternalAPIDeliveryAndDestinationCharges(postalObj.itemJsonId,queryParams.type))
    }else if(mode === "pickupDelivery"){
        if (matchingObject?.pickup_section?.[0]?.rate?.length && !matchingObject?.delivery_section?.[0]?.rate?.length) {
            dispatch({ type: SET_DELIVERY_POSTAL_CODE, payload: "" });
            const message = "Delivery charges are not available for the given postal code."
            dispatch(setDeliveryChargeError(postalObj.itemJsonId, message, queryParams.type))
        }else if(matchingObject?.delivery_section?.[0]?.rate?.length && !matchingObject?.pickup_section?.[0]?.rate?.length){
            console.log("only delivery charges available...........")
            dispatch({ type: SET_PICKUP_POSTAL_CODE, payload: "" });
            const message = "Pick up charges are not available for the given postal code."
            dispatch(setPickupChargeError(postalObj.itemJsonId, message, queryParams.type))
        }else {
            console.Warn("charges are not available for the selected door locations")
            //const message = `Charges are not available for the selected door locations`
            //reset all charges and locations
            dispatch(resetAllLclChargesAndDoorLocations());
            dispatch(resetContainersTypeSliders());
            // dispatch(updateErrorAndLoading(message, undefined));
        }
    }

    if (callback) {
        callback(false);
    }
    return;
}

/**
 * @function
 * @name postZipCodeData
 * @description  It's for posting zip code when user enters postal code and click on Submit on a rate card on search page.
 * In form mode it is auto submitted after form is submitted successfully
 * @param {Object} postalObj - postal data
 * @param {Function} [callback=undefined] - callback
 * @param {boolean} formZipCodeSubmit - `true` - used for Form page, `false` - used for search page
 * @returns {Redux.Action} The generated action
 */

// formZipCodeSubmit boolean is for zip code submit from search mode or form mode
export const postZipCodeData =
    (postalObj, callback = undefined, formZipCodeSubmit = undefined) =>
        async (dispatch, getState) => {
            let response = {};
            try {
                const {origin, ...restPostalObj} = postalObj;

                let inputParams = {
                    apiKey: API_KEY,
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                    referral_code: getState().code_config.referralData.referral_code,
                    referral_type: getState().code_config.referralData.referral_type,
                    zipCode: restPostalObj,
                };

                let queryParams = getState().route.queryParams;

                //add google recaptcha res code if showform=false and user is not present
                const {user, verification} = getState().code_config.initAuth;

                const isUserPresent = user && verification ? true : false;
                if (!getState().form.isFormSubmitSuccess && !isUserPresent) {
                    inputParams.gre_res = getState().code_config.reCaptchaResCode;
                }

                let data = {};
                if (getState().form.isFormSubmitSuccess) {
                    data.form_params = {};
                    if (getState().code_config.showFormCustomService) {
                        data.form_params.customService = getState().form.customService;
                    }
                    // data.form_params.pickup = getState().form.pickup;
                    data.form_params.pickup = cleanPickupDeliveryJson(
                        getState,
                        'pickup'
                    ).newDataJson;
                    // data.form_params.pickup = {
                    //   ...(data.form_params.pickup || {}),
                    //   ...getFormSelectedPort('pickup', getState),
                    // };
                    // data.form_params.delivery = getState().form.delivery;
                    data.form_params.delivery = cleanPickupDeliveryJson(
                        getState,
                        'delivery'
                    ).newDataJson;
                    // data.form_params.delivery = {
                    //   ...(data.form_params.delivery || {}),
                    //   ...getFormSelectedPort('delivery', getState),
                    // };
                    data.form_params.type = data.type;
                    data.form_params.factoryInfo = getState().form.factoryInfo;
                } else {
                    data.form_params = getSearchBookSaveParams({}, getState);
                    data.form_params.type = data.type;
                }

                if (queryParams.type === 'api-lcl') {
                    data.form_params.total_shipment = getState().code_config.lclShipment;
                } else if (queryParams.type === 'api-air') {
                    data.form_params.total_shipment = getState().code_config.airShipment;
                } else {
                    const tempContainer = getState().code_config.fclCounters;
                    let tempContainerArr = [];
                    if (tempContainer._20stCounter) {
                        tempContainerArr.push({
                            input: tempContainer._20stCounter,
                            type: "20'",
                            isOverweight: null,
                        });
                    }
                    if (tempContainer._40stCounter) {
                        tempContainerArr.push({
                            input: tempContainer._40stCounter,
                            type: "40'",
                            isOverweight: null,
                        });
                    }
                    if (tempContainer._40hqCounter) {
                        tempContainerArr.push({
                            input: tempContainer._40hqCounter,
                            type: "40'HC",
                            isOverweight: null,
                        });
                    }
                    if (!REMOVE_FCL_45_HC_CONTAINER && tempContainer._45hqCounter) {
                        tempContainerArr.push({
                            input: tempContainer._45hqCounter,
                            type: "45'HC",
                            isOverweight: null,
                        });
                    }
                    data.form_params.fclShipping = tempContainerArr;
                }

                data.object_type = 'postal_code_submit'; //for postal code

                const tempData = {
                    form_params: {...data.form_params, origin},
                    // selected_card_json: data.selected_card_json,
                    // selected_card_detail: data.selected_card_detail,
                    object_type: data.object_type,
                };
                inputParams = {
                    ...inputParams,
                    ...tempData,
                };

                // console.log('zipcode inputParams', inputParams);
                // return;

                dispatch(updateErrorAndLoading(undefined, true));
                let payload ={};
                let mode = postalObj?.mode;
                if (queryParams.type === 'api-lcl') {
                    const pickupPostalCode = getState()?.route?.pickup_postal_code
                    const deliveryPostalCode = getState()?.route?.delivery_postal_code
                    // console.log("pickupPostalCode: ",pickupPostalCode, "\ndeliveryPostalCode: ",deliveryPostalCode)
                    if(pickupPostalCode || deliveryPostalCode){
                        // Re-derive effective mode from authoritative Redux state.
                        // The component's effectiveMode check can be stale for web users
                        // (this.props reflects the last render, not the current Redux state).
                        if (mode === 'delivery' && pickupPostalCode) {
                            mode = 'pickupDelivery';
                            postalObj = { ...postalObj, mode: 'pickupDelivery' };
                        } else if (mode === 'pickup' && deliveryPostalCode) {
                            mode = 'pickupDelivery';
                            postalObj = { ...postalObj, mode: 'pickupDelivery' };
                        }
                        return await dispatch(postDoorLocationData(postalObj, inputParams?.form_params?.total_shipment, mode, callback, formZipCodeSubmit));
                    }
                    dispatch(
                        setFormZipCodeSubmitLoading({
                            ...(postalObj.mode === 'pickup' && {isPickupLoading: false}),
                            ...(postalObj.mode === 'delivery' && {isDeliveryLoading: false}),
                        })
                    );
                    return;

                }else if(queryParams.type === 'api-fcl'){
                    // console.log("-----FCL---------", postalObj,
                    //     "postalObj?.zipCode: ",postalObj?.zipCode,
                    //     "\n getState: ",getState()
                    // );
                    const effectivePostalCode = postalObj?.zipCode

                    if(effectivePostalCode){
                        if (postalObj?.mode === 'delivery') {
                            dispatch(setDeliveryPostalCode(effectivePostalCode));
                        } else if (postalObj?.mode === 'pickup') {
                            dispatch(setPickupPostalCode(effectivePostalCode));
                        }
                        return await dispatch(postDoorLocationData(postalObj, inputParams?.form_params?.total_shipment, mode, callback, formZipCodeSubmit));
                    }
                    // Stop the spinner
                    dispatch(
                        setFormZipCodeSubmitLoading({
                            ...(postalObj.mode === 'pickup' && {isPickupLoading: false}),
                            ...(postalObj.mode === 'delivery' && {isDeliveryLoading: false}),
                        })
                    );
                    // Call callback to indicate completion
                    if (callback) {
                        callback(false);
                    }
                    return;
                }else{
                    if (isDevENV()) {
                        await new Promise((resolve) => setTimeout(() => resolve(), 2000));
                        response.data = localZipCodePostJSON;
                        response.data = {
                            ...response.data,
                            name: `${
                                formZipCodeSubmit ? 'Form mode' : 'Search mode'
                            }-New Zip code Type - Vehicle`,
                        };
                    } else {
                        // Make.com zip webhook RETIRED (door-estimate P4b) — it must never be
                        // the to-door price anywhere. This branch only ran for AIR (FCL/LCL
                        // return above via postDoorLocationData); air has no instant to-door
                        // drayage, so resolve to an empty response and let the leg be quoted
                        // via RFQ. To-door pricing lives solely in Montreal-defaults +
                        // selling-rate delivery (settingReduxStore), never here.
                        response = { data: {} };
                        // if option has a rate property
                        if (
                            !formZipCodeSubmit &&
                            postalObj.option &&
                            postalObj.option.rate &&
                            (response.data === 0 || isEmpty(response.data) || !response.data)
                        ) {
                            // console.log('empty res?: ',  response.data);
                            // revert to rate obj
                            response.data = {
                                ...(postalObj.option || {}),
                                fetch_zip_code: false,
                            };
                            // console.log('new option: ', response.data);
                        }
                    }

                    // save postal code response
                    postalObj = {
                        ...postalObj,
                        option: response.data && !isEmpty(response.data) ? response.data : {},
                        ...(formZipCodeSubmit && {formZipCodeSubmit}), //only for form zip code submit for new/existing factory
                    };
                    // console.log('zip code req postalObj: ', postalObj);
                    //update fcl/lcl/air json in new function
                    updateJsonAfterPostalSubmit(postalObj, getState, dispatch);
                    dispatch(updateErrorAndLoading(undefined, undefined));
                    if (callback) {
                        callback(true);
                    }
                }
            } catch (err) {
                console.log('zip code post error:', err);
                // for axios timeout error
                if (
                    !formZipCodeSubmit &&
                    postalObj.option &&
                    postalObj.option.rate &&
                    err.code === 'ECONNABORTED'
                ) {
                    console.log('axios timeout :(');
                    // revert to rate obj
                    response.data = {
                        ...(postalObj.option || {}),
                        fetch_zip_code: false,
                    };
                    // save postal code response
                    postalObj = {
                        ...postalObj,
                        ...(postalObj.option &&
                            postalObj.option.rate && {
                                option:
                                    response.data && !isEmpty(response.data) ? response.data : {},
                            }),
                    };
                    console.log('axios timeout new postalObj: ', postalObj);
                    //update fcl/lcl/air json in new function
                    updateJsonAfterPostalSubmit(postalObj, getState, dispatch);

                    if (callback) {
                        callback(false);
                    }
                    dispatch(updateErrorAndLoading(undefined, undefined));
                    return;
                }
                if (callback) {
                    callback(false);
                }
                dispatch(updateErrorAndLoading(JSON.stringify(err.message), undefined));
            }

            // stop form zip code loading
            dispatch(
                setFormZipCodeSubmitLoading({
                    ...(postalObj.mode === 'pickup' && {isPickupLoading: false}),
                    ...(postalObj.mode === 'delivery' && {isDeliveryLoading: false}),
                })
            );
};
/**
* Updates or inserts a zip code item into the zipCode array based on specific conditions.
*
* - If an item with the same `mode` and `zipCode` already exists AND has a non-empty `rate` array,
*   it will be replaced with the new item.
* - If no such item exists, the new item will be added to the array.
*
* @param {Array} zipCodeArray - The array of zip code items to update.
* @param {Object} newItem - The new item to insert or use as a replacement.
* @returns {Array} - The updated zip code array.
*/
function insertZipCodeItem(zipCodeArray, newItem) {
   const index = zipCodeArray.findIndex(item =>
       item.mode === newItem.mode &&
       item.zipCode === newItem.zipCode &&
       Array.isArray(item?.option?.rate) &&
       item?.option?.rate.length > 0
   );
//    console.log("index: ",index)

   if (index !== -1) {
       // Replace the existing item
       zipCodeArray[index] = newItem;
   } else {
       // Optionally add it if no match was found
       zipCodeArray.push(newItem);
   }
   return zipCodeArray;
 }
/**
 * @function
 * @name updateJsonAfterPostalSubmit
 * @description  It updates fcl/lcl/air json after getting postal code response
 * @param {Object} postalObj - postal data
 * @param {Redux.State} getState - whole redux state
 * @param {Function} dispatch - dispatch function
 * @returns {Redux.Action} The generated action
 */
export const updateJsonAfterPostalSubmit = (postalObj, getState, dispatch) => {
    // save postal code response
    let tempSaveObj = {
        itemJsonId: postalObj.itemJsonId,
        mode: postalObj.mode,
        optionMode: postalObj.optionMode,
        optionId: postalObj.optionId, //fetch zip code = true obj id
        zipCode: postalObj.zipCode,
        option: postalObj.option, //non zip code option object, modified by axios post request response
        ...(postalObj.formZipCodeSubmit && {
            formZipCodeSubmit: postalObj.formZipCodeSubmit,
        }), //only for form zip code submit for new/existing factory
    };

    let zipCodeArr = [...getState().route.zipCodeArr];
    // console.log("---zipCodeArr------",zipCodeArr,"tempSaveObj: ",tempSaveObj)
    zipCodeArr = insertZipCodeItem(zipCodeArr, tempSaveObj)
    // console.log("zipCodeArr: ",zipCodeArr)
    dispatch({
        type: UPDATE_POSTAL_ZIP_CODE,
        payload: zipCodeArr,
    });

    // fclActive, lclActive, airActve are boolean
    const {fclActive, lclActive, airActve} = getActiveShipmentMode(getState);
    const seaFCLJSON = getState().route.seaFCLJSON;
    const seaLCLJSON = getState().route.seaLCLJSON;
    const airJSON = getState().route.airJSON;

    let tempSeaFCLJSON = {
        ...(seaFCLJSON || {}),
    };
    let tempSeaLCLJSON = {
        ...(seaLCLJSON || {}),
    };
    let tempAirJSON = {
        ...(airJSON || {}),
    };

    zipCodeArr = getState().route.zipCodeArr;

    // get zip code and update corresponding fcl/lcl/air json
    zipCodeArr.map((optionItemObj) => {
        if (fclActive) {
            // get temp updated fcl json
            tempSeaFCLJSON = getPostalUpdatedFclLclAirJson(
                tempSeaFCLJSON,
                getState,
                optionItemObj
            );
        } else if (lclActive) {
            // get temp updated lcl json
            tempSeaLCLJSON = getPostalUpdatedFclLclAirJson(
                tempSeaLCLJSON,
                getState,
                optionItemObj
            );
        } else if (airActve) {
            // get temp updated air json
            tempAirJSON = getPostalUpdatedFclLclAirJson(
                tempAirJSON,
                getState,
                optionItemObj
            );
        }
    });

    // console.log({ fclActive, lclActive, airActve });

    fclActive &&
    dispatch({
        type: SET_SEA_FCL_JSON,
        payload: tempSeaFCLJSON,
    }); //it will auto set empty obj to lcl/air json ;

    lclActive &&
    dispatch({
        type: SET_SEA_LCL_JSON,
        payload: tempSeaLCLJSON,
    });

    airActve &&
    dispatch({
        type: SET_AIR_JSON,
        payload: tempAirJSON,
    });

    // remove old zipcode arr after it has been updated in rates json
    //TODO- it is newly added here, it was not here before, check it couple of times
    dispatch({
        type: UPDATE_POSTAL_ZIP_CODE,
        payload: [], //set it empty now
    });

    // re-render pickup delivery ers line upon submitting postal codes
    dispatch({
        type: UPDATE_PICKUP_DELIVERY_ERS_LINE,
    });
};

/**
 * @function
 * @name postSailingSchedule
 * @description  It's for sailing schedule post request on search page.
 * @param {Object} itemJson - single rate card json on which sailing schedule is clicked on
 * @param {Function} [callback=undefined] - callback
 * @returns {Redux.Action} The generated action
 */
export const postSailingSchedule =
    (itemJson, callback = undefined) =>
        async (dispatch, getState) => {
            try {
                // const username = getState().config.username;

                // cancel previous axios post request if present
                if (window.sailing_schedule_axios_source) {
                    window.sailing_schedule_axios_source.cancel();
                }
                axios.defaults.timeout = 200000; //200 seconds
                const CancelToken = axios.CancelToken;
                window.sailing_schedule_axios_source = CancelToken.source();

                let axiosConfig = {
                    // headers: {
                    //   'Content-Type': 'application/json',
                    //   Authorization: `Bearer ${AUTH_TOKEN}`,
                    //   user: getState().code_config.initAuth.user,
                    //   verification: getState().code_config.initAuth.verification,
                    // },
                    cancelToken: window.sailing_schedule_axios_source.token,
                };

                const params = {
                    apiKey: API_KEY,
                    Authorization: `Bearer ${AUTH_TOKEN}`,
                    user: getState().code_config.initAuth.user,
                    verification: getState().code_config.initAuth.verification,
                    referral_code: getState().code_config.referralData.referral_code,
                    referral_type: getState().code_config.referralData.referral_type,
                    itemJson,
                    object_type: 'sailing_schedule',
                    show_variable_rate: !!itemJson.show_variable_rate,
                    //port to/from (get it from url), date,
                    ...getSailingPOSTparam(
                        getState().form.isFormSubmitSuccess,
                        getState().route.queryParams
                    ),
                    //  carrier, discharge port
                    port_of_discharge: itemJson.port_of_discharge || '',
                    carrier: itemJson.sealine || itemJson.company_name || '',
                    // transhipment_ports
                    ...(itemJson.transhipment_ports && {
                        transhipment_ports: itemJson.transhipment_ports,
                    }),
                };

                // console.log('sailing schedule params : ', params);

                // dispatch(updateErrorAndLoading(undefined, true));

                let response = {};
                if (isDevENV()) {
                    await new Promise((resolve) => setTimeout(() => resolve(), 500));
                    response.data = localSailingScheduleJSON;
                } else {
                    let sailingScheduleTimeout = Number(
                        SEARCH_SAILING_SCHEDULE_TIMEOUT_MIN
                    );
                    sailingScheduleTimeout = isNaN(sailingScheduleTimeout)
                        ? 0
                        : sailingScheduleTimeout;
                    sailingScheduleTimeout = sailingScheduleTimeout * 60 * 1000; //turn min to miliseconds
                    if (sailingScheduleTimeout) {
                        axios.defaults.timeout = sailingScheduleTimeout;
                    }

                    let url = SAILING_SCHEDULE_POST_URL;
                    // url = 'http://localhost:5000/sailing-schedule'; // remove this, it is for test
                    response = await axios.post(url, {params}, axiosConfig);
                }

                // console.log('response : ', response.data);

                //reset sailing modal marginTop position
                dispatch(updateParentScrollbarPosition(0));

                if (callback) {
                    callback({success: true, resJson: response.data || {}});
                }
                dispatch(updateErrorAndLoading(undefined, undefined));
            } catch (err) {
                console.log('error: ', err);
                dispatch(updateErrorAndLoading(err.message, undefined));
                if (callback) {
                    callback({success: false});
                }
                if (axios.isCancel(err)) {
                    console.log('previous token is canceled!');
                    // keep spinning if the previous token is cancelled
                    // because a current request is going on
                    // dispatch(updateErrorAndLoading(undefined, true));
                }
            }
        };

// (removed) postUserEmailBlurCards — the legacy blur-cards email→Make.com webhook.
// Superseded by the rate-gate unlock flow (rate_gate_actions.unlockRates →
// /api/rate-gate/unlock). It had zero callers; deleted with its REACT_APP_USER_EMAIL_
// BLUR_CARDS_POST_URL env var (door-estimate P4).

export const validateUserEntityForBreezeApiFromApi = (isUserPresent) => async (dispatch,getState) => {
  try {
    const response = await validateUserEntityForBreezeApi(isUserPresent, getState);
    return response;
  } catch (error) {
    console.error(error);
  }
}

export const updateEntityLocationFromApi = (locationFields, isUserPresent) => async (dispatch, getState) => {
  try {
    const response = await updateEntityLocation(locationFields, isUserPresent, getState);
    return response;
  } catch (error) {
    console.error(error);
  }
}
